export type Maybe<T> = T | undefined;
export type InputMaybe<T> = T | undefined;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = {
	[_ in K]?: never;
};
export type Incremental<T> =
	| T
	| { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
	ID: { input: string; output: string };
	String: { input: string; output: string };
	Boolean: { input: boolean; output: boolean };
	Int: { input: number; output: number };
	Float: { input: number; output: number };
	/** Date custom scalar type */
	Date: { input: any; output: any };
};

export type AccountEmergencyContact = {
	__typename?: 'AccountEmergencyContact';
	address: Address;
	cellPhone: PhoneNumber;
	email?: Maybe<Scalars['String']['output']>;
	firstName: Scalars['String']['output'];
	lastName: Scalars['String']['output'];
	otherPhone?: Maybe<PhoneNumber>;
	relationship: Scalars['String']['output'];
	userId: Scalars['ID']['output'];
};

export type AccountEmergencyContactUpdate = {
	address: AddressInput;
	cellPhone: PhoneNumberInput;
	email?: InputMaybe<Scalars['String']['input']>;
	firstName: Scalars['String']['input'];
	lastName: Scalars['String']['input'];
	otherPhone?: InputMaybe<PhoneNumberInput>;
	relationship: Scalars['String']['input'];
};

export enum ActivationOperation {
	Activate = 'Activate',
	Deactivate = 'Deactivate',
}

export enum ActivationStatus {
	Active = 'Active',
	Inactive = 'Inactive',
}

export type AdHocBillingItem = {
	__typename?: 'AdHocBillingItem';
	description?: Maybe<Scalars['String']['output']>;
	externalOrganizationId: Scalars['String']['output'];
	id: Scalars['ID']['output'];
	quantity: Scalars['Float']['output'];
	recurring: Scalars['Boolean']['output'];
	serviceDate?: Maybe<Scalars['Date']['output']>;
	stripePriceId?: Maybe<Scalars['String']['output']>;
	stripeProductId: Scalars['String']['output'];
	unitPrice?: Maybe<Scalars['Float']['output']>;
};

export type AdHocBillingItemUpdate = {
	description?: InputMaybe<Scalars['String']['input']>;
	quantity: Scalars['Float']['input'];
	recurring: Scalars['Boolean']['input'];
	serviceDate?: InputMaybe<Scalars['Date']['input']>;
	stripePriceId?: InputMaybe<Scalars['String']['input']>;
	stripeProductId: Scalars['String']['input'];
	unitPrice?: InputMaybe<Scalars['Float']['input']>;
};

export type AdHocBillingItemsResponse = {
	__typename?: 'AdHocBillingItemsResponse';
	adHocBillingItems: Array<AdHocBillingItem>;
};

export type Address = {
	__typename?: 'Address';
	address1?: Maybe<Scalars['String']['output']>;
	address2?: Maybe<Scalars['String']['output']>;
	adminArea1?: Maybe<AddressFieldLookup>;
	adminArea1Id?: Maybe<Scalars['String']['output']>;
	adminArea2?: Maybe<AddressFieldLookup>;
	adminArea2Id?: Maybe<Scalars['String']['output']>;
	coordinate?: Maybe<Location>;
	countryId: Scalars['String']['output'];
	municipality?: Maybe<Scalars['String']['output']>;
	postalCode?: Maybe<Scalars['String']['output']>;
};

export type AddressFieldLookup = {
	__typename?: 'AddressFieldLookup';
	displayName?: Maybe<Scalars['String']['output']>;
	displayOrder?: Maybe<Scalars['Int']['output']>;
	field?: Maybe<Scalars['String']['output']>;
	id: Scalars['ID']['output'];
	value?: Maybe<Scalars['String']['output']>;
};

export type AddressInput = {
	address1?: InputMaybe<Scalars['String']['input']>;
	address2?: InputMaybe<Scalars['String']['input']>;
	adminArea1Id?: InputMaybe<Scalars['String']['input']>;
	adminArea2Id?: InputMaybe<Scalars['String']['input']>;
	coordinate?: InputMaybe<LocationInput>;
	countryId: Scalars['String']['input'];
	municipality?: InputMaybe<Scalars['String']['input']>;
	postalCode?: InputMaybe<Scalars['String']['input']>;
};

export type AdjusterLicensingSummaries = {
	__typename?: 'AdjusterLicensingSummaries';
	summaries: Array<AdjusterLicensingSummary>;
	userId: Scalars['ID']['output'];
};

export type AdjusterLicensingSummary = {
	__typename?: 'AdjusterLicensingSummary';
	activeRegionIds?: Maybe<Array<Scalars['String']['output']>>;
	adjusterLicensingText?: Maybe<Scalars['String']['output']>;
	adjusterLicensingTextSensitive?: Maybe<Scalars['String']['output']>;
	countryId: Scalars['String']['output'];
	expiredRegionIds?: Maybe<Array<Scalars['String']['output']>>;
	expiringRegionIds?: Maybe<Array<Scalars['String']['output']>>;
	inactiveRegionIds?: Maybe<Array<Scalars['String']['output']>>;
	licenseHoldersName?: Maybe<Scalars['String']['output']>;
	licensingProvenance: Scalars['String']['output'];
	numActiveLicenses: Scalars['Int']['output'];
	numExpiredLicenses: Scalars['Int']['output'];
	numExpiredWithin60DaysLicenses: Scalars['Int']['output'];
	numLicenses: Scalars['Int']['output'];
	userId: Scalars['String']['output'];
};

export type AdjustmentCompanyInfo = {
	__typename?: 'AdjustmentCompanyInfo';
	acid: Scalars['Float']['output'];
	address1?: Maybe<Scalars['String']['output']>;
	address2?: Maybe<Scalars['String']['output']>;
	city?: Maybe<Scalars['String']['output']>;
	country?: Maybe<Scalars['String']['output']>;
	logo?: Maybe<Scalars['String']['output']>;
	name?: Maybe<Scalars['String']['output']>;
	state?: Maybe<Scalars['String']['output']>;
	systemId: Scalars['Float']['output'];
	systemUrl: Scalars['String']['output'];
	zipCode?: Maybe<Scalars['String']['output']>;
};

export enum AllowableFileAccessLevels {
	Confidential = 'Confidential',
	None = 'None',
	Public = 'Public',
	Sensitive = 'Sensitive',
}

export enum AllowedTransports {
	All = 'All',
	DailyDigest = 'DailyDigest',
	Email = 'Email',
	HourlyDigest = 'HourlyDigest',
	InApp = 'InApp',
	None = 'None',
	Sms = 'Sms',
}

export type AppSettings = {
	__typename?: 'AppSettings';
	name: Scalars['String']['output'];
	subSettings?: Maybe<Array<AppSettings>>;
	value?: Maybe<Scalars['String']['output']>;
};

export type AssociateInvitation = {
	__typename?: 'AssociateInvitation';
	avatarFile?: Maybe<File>;
	id: Scalars['ID']['output'];
	organizationId: Scalars['String']['output'];
	organizationName: Scalars['String']['output'];
};

export type AssociateInvitationRequest = {
	displayName: Scalars['String']['input'];
	emailAddress: Scalars['String']['input'];
	roleId: Scalars['String']['input'];
};

export type AssociateInvitationsResponse = {
	__typename?: 'AssociateInvitationsResponse';
	invitations: Array<AssociateInvitation>;
};

export type AssociateOrInvitation = {
	__typename?: 'AssociateOrInvitation';
	associateId?: Maybe<Scalars['String']['output']>;
	deactivated?: Maybe<Scalars['Boolean']['output']>;
	displayName: Scalars['String']['output'];
	displayOnProfile?: Maybe<Scalars['Boolean']['output']>;
	emailAddress: Scalars['String']['output'];
	externalUserDisplayName?: Maybe<Scalars['String']['output']>;
	externalUserHandle?: Maybe<Scalars['String']['output']>;
	invitationId?: Maybe<Scalars['String']['output']>;
	lastUpdatedUtc: Scalars['Date']['output'];
	organizationId: Scalars['String']['output'];
	organizationName: Scalars['String']['output'];
	organizationRoleId: Scalars['String']['output'];
	organizationRoleName?: Maybe<Scalars['String']['output']>;
	status: Scalars['String']['output'];
	userId?: Maybe<Scalars['String']['output']>;
};

export type AssociateUpdate = {
	displayName: Scalars['String']['input'];
	displayOnProfile: Scalars['Boolean']['input'];
	emailAddress: Scalars['String']['input'];
	organizationRoleId: Scalars['String']['input'];
};

export type AssociatesToBeSeededCountResponse = {
	__typename?: 'AssociatesToBeSeededCountResponse';
	count: Scalars['Float']['output'];
};

export type BillingAlert = {
	__typename?: 'BillingAlert';
	description: Scalars['String']['output'];
	severity: BillingAlertSeverity;
};

export enum BillingAlertSeverity {
	Critical = 'Critical',
	Information = 'Information',
	Warning = 'Warning',
}

export type BillingHierarchyValidationResults = {
	__typename?: 'BillingHierarchyValidationResults';
	errors: Array<Scalars['String']['output']>;
};

export type BillingInfoResponse = {
	__typename?: 'BillingInfoResponse';
	alerts: Array<BillingAlert>;
	canGoToPortal: Scalars['Boolean']['output'];
	inheritedFromRootOrganization: Scalars['Boolean']['output'];
	planInformation?: Maybe<BillingPlanInformation>;
};

export type BillingPlanInformation = {
	__typename?: 'BillingPlanInformation';
	planInterval: Scalars['String']['output'];
	planName: Scalars['String']['output'];
	planPrice: Scalars['Float']['output'];
};

export type BillingUsage = {
	appraisalCount: Scalars['Float']['input'];
	appraisalCountDeleted: Scalars['Float']['input'];
	bordereau: Scalars['Float']['input'];
	claimCount: Scalars['Float']['input'];
	claimCountDeleted: Scalars['Float']['input'];
	hoverCount: Scalars['Float']['input'];
	odysseyCount: Scalars['Float']['input'];
	storageActive: Scalars['Float']['input'];
	storageDate: Scalars['Date']['input'];
	symbilityCount: Scalars['Float']['input'];
	textMessageCount: Scalars['Float']['input'];
	torrentCount: Scalars['Float']['input'];
	userCount: Scalars['Float']['input'];
	xactCount: Scalars['Float']['input'];
};

export type BusinessLine = {
	__typename?: 'BusinessLine';
	id: Scalars['ID']['output'];
	line?: Maybe<Scalars['String']['output']>;
	specialty?: Maybe<Scalars['Boolean']['output']>;
	text?: Maybe<Scalars['String']['output']>;
};

export type BusinessLineUpdate = {
	line?: InputMaybe<Scalars['String']['input']>;
	specialty?: InputMaybe<Scalars['Boolean']['input']>;
	text?: InputMaybe<Scalars['String']['input']>;
};

export type Callout = {
	__typename?: 'Callout';
	color?: Maybe<Scalars['String']['output']>;
	icon?: Maybe<Scalars['String']['output']>;
	id: Scalars['ID']['output'];
	text?: Maybe<Scalars['String']['output']>;
};

export type CalloutUpdate = {
	color?: InputMaybe<Scalars['String']['input']>;
	icon?: InputMaybe<Scalars['String']['input']>;
	text?: InputMaybe<Scalars['String']['input']>;
};

export type CanAdjusterLicensingInput = {
	ciprNumber: Scalars['String']['input'];
	provincesLicensing: Array<CanProvinceAdjusterLicensingInput>;
};

export type CanAdjusterLicensingOutput = {
	__typename?: 'CanAdjusterLicensingOutput';
	ciprNumber: Scalars['String']['output'];
	provincesLicensing: Array<CanProvinceAdjusterLicensingOutput>;
};

export type CanCallerLinkResult = {
	__typename?: 'CanCallerLinkResult';
	canLink: Scalars['Boolean']['output'];
};

export type CanLicenseTypeLookup = {
	__typename?: 'CanLicenseTypeLookup';
	id: Scalars['String']['output'];
	name: Scalars['String']['output'];
	provinceId: Scalars['String']['output'];
};

export type CanProvinceAdjusterLicenseInput = {
	adjusterAlias?: InputMaybe<Scalars['String']['input']>;
	designation: Scalars['String']['input'];
	expirationDate?: InputMaybe<Scalars['Date']['input']>;
	licenseTypeId: Scalars['String']['input'];
	number: Scalars['String']['input'];
	originalIssueDate?: InputMaybe<Scalars['Date']['input']>;
	supervisingEntity?: InputMaybe<Scalars['String']['input']>;
};

export type CanProvinceAdjusterLicenseOutput = {
	__typename?: 'CanProvinceAdjusterLicenseOutput';
	adjusterAlias?: Maybe<Scalars['String']['output']>;
	designation: Scalars['String']['output'];
	expirationDate?: Maybe<Scalars['Date']['output']>;
	licenseTypeId: Scalars['String']['output'];
	number: Scalars['String']['output'];
	originalIssueDate?: Maybe<Scalars['Date']['output']>;
	supervisingEntity?: Maybe<Scalars['String']['output']>;
};

export type CanProvinceAdjusterLicensingInput = {
	provinceAddressFieldLookupId: Scalars['String']['input'];
	provinceLicenses: Array<CanProvinceAdjusterLicenseInput>;
};

export type CanProvinceAdjusterLicensingOutput = {
	__typename?: 'CanProvinceAdjusterLicensingOutput';
	provinceAddressFieldLookupId: Scalars['String']['output'];
	provinceLicenses: Array<CanProvinceAdjusterLicenseOutput>;
};

export type ChangeFileFolderRequest = {
	fileIds: Array<Scalars['String']['input']>;
	folderId?: InputMaybe<Scalars['String']['input']>;
};

export type ChangedValue = {
	__typename?: 'ChangedValue';
	changeType: Scalars['String']['output'];
	entityId?: Maybe<Scalars['String']['output']>;
	fieldName: Scalars['String']['output'];
	newValue?: Maybe<Scalars['String']['output']>;
	oldValue?: Maybe<Scalars['String']['output']>;
};

/** The source of an EVO-X conversation. */
export enum ChatConversationSource {
	EvolveOrganization = 'EvolveOrganization',
	EvolveUser = 'EvolveUser',
	FileTracLegacy = 'FileTracLegacy',
}

/** The type of an EVO-X conversation. */
export enum ChatConversationType {
	ClaimNotesSummary = 'ClaimNotesSummary',
	GeneralChat = 'GeneralChat',
	MessagingDraft = 'MessagingDraft',
}

/** Request object for when loading a file for use in a chat conversation. */
export type ChatFileRequest = {
	/** The conversation ID. */
	conversationId: Scalars['ID']['input'];
	/** The file service upload token of the file to be imported for chat. */
	fileUploadToken: Scalars['String']['input'];
};

/** Represents feedback for a chat message. */
export type ChatMessageFeedback = {
	/** The feedback comments. */
	comments?: InputMaybe<Scalars['String']['input']>;
	/** The feedback rating. */
	rating: Scalars['String']['input'];
};

/** Indicates the rating of a chat message. */
export enum ChatMessageRating {
	None = 'None',
	ThumbsDown = 'ThumbsDown',
	ThumbsUp = 'ThumbsUp',
}

/** Indicates the role of the chat message creator. */
export enum ChatMessageRole {
	Assistant = 'Assistant',
	FunctionResultsForAi = 'FunctionResultsForAi',
	FunctionResultsForUser = 'FunctionResultsForUser',
	System = 'System',
	User = 'User',
}

/** Claim note details. */
export type ClaimNote = {
	/** The datetime of the message. */
	dateTimeUtc: Scalars['Date']['input'];
	/** The note text. */
	text?: InputMaybe<Scalars['String']['input']>;
	/** The name of the note author. */
	user?: InputMaybe<Scalars['String']['input']>;
};

/** Claim details for a claim on which we are summarizing claim notes. */
export type ClaimNotesSummaryClaimDetails = {
	/** The claim number. */
	claimNumber?: InputMaybe<Scalars['String']['input']>;
	/** The status of the claim. */
	claimStatus?: InputMaybe<Scalars['String']['input']>;
	/** The name of the client company (carrier). */
	clientCompany?: InputMaybe<Scalars['String']['input']>;
	/** The name of the insured. */
	insuredName?: InputMaybe<Scalars['String']['input']>;
	/** The loss date of the claim. */
	lossDate?: InputMaybe<Scalars['Date']['input']>;
	/** The address of the loss (concatenates address, city, state, zip). */
	lossLocation?: InputMaybe<Scalars['String']['input']>;
	/** The type of loss. */
	lossType?: InputMaybe<Scalars['String']['input']>;
	/** The policy number. */
	policyNumber?: InputMaybe<Scalars['String']['input']>;
};

/** Claim notes summary request. */
export type ClaimNotesSummaryRequest = {
	/** The chat conversation ID, when continuing an existing conversation. */
	chatConversationId?: InputMaybe<Scalars['ID']['input']>;
	/** The details of the claim for which we are summarizing claim notes. */
	claimDetails?: InputMaybe<ClaimNotesSummaryClaimDetails>;
	/** An array of claim notes. */
	claimNotes?: InputMaybe<Array<ClaimNote>>;
	/** A serialized json string containing any metadata the legacy caller wants to include (e.g. acid, system, claimid, filter params, etc.) For forensic purposes only. */
	metadata?: InputMaybe<Scalars['String']['input']>;
	/** The prompt from the user (i.e. during a follow-up conversation about a generated summary). */
	prompt?: InputMaybe<Scalars['String']['input']>;
	/** The ID for the Evolve user associated with this request. */
	userId: Scalars['ID']['input'];
};

/** Claim notes summary response. */
export type ClaimNotesSummaryResponse = {
	__typename?: 'ClaimNotesSummaryResponse';
	/** The ID of the chat conversation. */
	chatConversationId: Scalars['ID']['output'];
	/** The generated reply. */
	message?: Maybe<Scalars['String']['output']>;
};

export enum ClaimSummaryRoleType {
	Group = 'Group',
	User = 'User',
}

export enum ClaimSummarySubset {
	DueNext3 = 'DueNext3',
	Overdue = 'Overdue',
	RecLast3 = 'RecLast3',
}

export type CognitoDevice = {
	__typename?: 'CognitoDevice';
	createdAtUtc: Scalars['Date']['output'];
	lastAuthenticatedUtc: Scalars['Date']['output'];
	lastIpUsed: Scalars['String']['output'];
	name: Scalars['String']['output'];
	remembered: Scalars['Boolean']['output'];
};

export type CognitoDevicesResponse = {
	__typename?: 'CognitoDevicesResponse';
	cognitoDevices?: Maybe<Array<CognitoDevice>>;
};

export type CognitoUserResponse = {
	__typename?: 'CognitoUserResponse';
	preferredMfaSetting?: Maybe<Scalars['String']['output']>;
};

export type Connection = {
	__typename?: 'Connection';
	id: Scalars['ID']['output'];
	requestingOrganizationEmblem?: Maybe<Emblem>;
	requestingOrganizationId?: Maybe<Scalars['String']['output']>;
	requestingUserEmblem?: Maybe<Emblem>;
	requestingUserId?: Maybe<Scalars['String']['output']>;
	state: ConnectionState;
	stateChangedDateTimeUtc: Scalars['Date']['output'];
	targetOrganizationEmblem?: Maybe<Emblem>;
	targetOrganizationId?: Maybe<Scalars['String']['output']>;
	targetUserEmblem?: Maybe<Emblem>;
	targetUserId?: Maybe<Scalars['String']['output']>;
};

export enum ConnectionPageType {
	MyConnections = 'MY_CONNECTIONS',
	Requests = 'REQUESTS',
	RequestsISent = 'REQUESTS_I_SENT',
}

export enum ConnectionSortBy {
	OtherDisplayName = 'OtherDisplayName',
	RequestingDisplayName = 'RequestingDisplayName',
	State = 'State',
	StateChangedDateTimeUtc = 'StateChangedDateTimeUtc',
	TargetDisplayName = 'TargetDisplayName',
}

export enum ConnectionState {
	Connected = 'Connected',
	Ignored = 'Ignored',
	Pending = 'Pending',
}

export type Conversation = {
	__typename?: 'Conversation';
	creatorEmblem: Emblem;
	creatorEntityId: Scalars['String']['output'];
	creatorEntityType: ParticipantEntityType;
	id: Scalars['ID']['output'];
	messages: Array<Message>;
	participants: Array<ConversationParticipant>;
	subject: Scalars['String']['output'];
};

export type ConversationAndSummary = {
	__typename?: 'ConversationAndSummary';
	conversation: Conversation;
	conversationSummary: ConversationSummary;
};

export enum ConversationApiEntityType {
	LegacyClaim = 'LegacyClaim',
	Organizations = 'Organizations',
	Users = 'Users',
}

export type ConversationInsuranceInput = {
	conversationInsuranceUrl?: InputMaybe<Scalars['String']['input']>;
};

export type ConversationInsuranceResponse = {
	__typename?: 'ConversationInsuranceResponse';
	conversationInsuranceUrl?: Maybe<Scalars['String']['output']>;
};

export type ConversationParticipant = {
	__typename?: 'ConversationParticipant';
	entityId: Scalars['String']['output'];
	entityType: ParticipantEntityType;
	isCurrentParticipant: Scalars['Boolean']['output'];
	participantLabels: Array<ParticipantLabel>;
};

export type ConversationSummariesResponse = {
	__typename?: 'ConversationSummariesResponse';
	conversationSummaries: Array<ConversationSummary>;
	labelId?: Maybe<Scalars['ID']['output']>;
	totalCount: Scalars['Int']['output'];
};

export type ConversationSummary = {
	__typename?: 'ConversationSummary';
	conversationId: Scalars['ID']['output'];
	emblemToDisplay?: Maybe<Emblem>;
	entityIdToDisplay: Scalars['String']['output'];
	entityTypeToDisplay: ParticipantEntityType;
	lastMessageDateTimeUtc: Scalars['Date']['output'];
	lastMessageIsFromCurrentEntity: Scalars['Boolean']['output'];
	lastMessagePreview?: Maybe<Scalars['String']['output']>;
	participantsCount: Scalars['Int']['output'];
	subject: Scalars['String']['output'];
	unreadMessageCount: Scalars['Int']['output'];
};

/** The type of an EVO-X conversation. */
export enum ConversationTypeFilter {
	ClaimNotesSummary = 'ClaimNotesSummary',
	GeneralChat = 'GeneralChat',
	MessagingDraft = 'MessagingDraft',
}

export type Country = {
	__typename?: 'Country';
	address1Label?: Maybe<Scalars['String']['output']>;
	address1Visibility: Scalars['String']['output'];
	address2Label?: Maybe<Scalars['String']['output']>;
	address2Visibility: Scalars['String']['output'];
	addressFieldLookups?: Maybe<Array<AddressFieldLookup>>;
	adminArea1Label?: Maybe<Scalars['String']['output']>;
	adminArea1Visibility: Scalars['String']['output'];
	adminArea2Label?: Maybe<Scalars['String']['output']>;
	adminArea2Visibility: Scalars['String']['output'];
	driversLicenseJurisdictionLevel?: Maybe<Scalars['String']['output']>;
	id: Scalars['String']['output'];
	iso2CountryCode: Scalars['String']['output'];
	iso3CountryCode: Scalars['String']['output'];
	municipalityLabel?: Maybe<Scalars['String']['output']>;
	municipalityVisibility: Scalars['String']['output'];
	name: Scalars['String']['output'];
	nationalIdentificationNumberLabel?: Maybe<Scalars['String']['output']>;
	nationalIdentificationNumberRegex?: Maybe<Scalars['String']['output']>;
	phoneNumberFormat?: Maybe<Scalars['String']['output']>;
	phonePrefix: Scalars['String']['output'];
	postalCodeLabel?: Maybe<Scalars['String']['output']>;
	postalCodeRegex?: Maybe<Scalars['String']['output']>;
	postalCodeVisibility: Scalars['String']['output'];
};

export type Coverages = {
	__typename?: 'Coverages';
	countryId: Scalars['String']['output'];
	policyCategories: Array<PolicyCategory>;
};

/** Request object for updating a users custom instructions. */
export type CustomInstructions = {
	__typename?: 'CustomInstructions';
	/** Sets the About text for the user. */
	about?: Maybe<Scalars['String']['output']>;
	/** Indicates whether this CustomInstructions is enabled. */
	enableCustomInstructions: Scalars['Boolean']['output'];
	/** Sets the response targeting text for the user. */
	responseTargeting?: Maybe<Scalars['String']['output']>;
};

/** Request object for updating a users custom instructions. */
export type CustomInstructionsInput = {
	/** Sets the About text for the user. */
	about?: InputMaybe<Scalars['String']['input']>;
	/** Indicates whether this CustomInstructions is enabled. */
	enableCustomInstructions: Scalars['Boolean']['input'];
	/** Sets the response targeting text for the user. */
	responseTargeting?: InputMaybe<Scalars['String']['input']>;
};

export type DisplayTemporaryLocation = {
	__typename?: 'DisplayTemporaryLocation';
	displayLocation: Scalars['String']['output'];
	endDate: Scalars['Date']['output'];
	startDate?: Maybe<Scalars['Date']['output']>;
};

export type Emblem = {
	__typename?: 'Emblem';
	avatarFile?: Maybe<File>;
	bannerFile?: Maybe<File>;
	deactivated?: Maybe<Scalars['Boolean']['output']>;
	displayName: Scalars['String']['output'];
	entityType: EmblemEntityType;
	extraData?: Maybe<UserExtraData>;
	handle?: Maybe<Scalars['String']['output']>;
	id: Scalars['ID']['output'];
	private?: Maybe<Scalars['Boolean']['output']>;
};

export enum EmblemEntityType {
	Conversation = 'Conversation',
	LegacyClaim = 'LegacyClaim',
	Organization = 'Organization',
	System = 'System',
	Unknown = 'Unknown',
	User = 'User',
}

export type EmblemPagingResponse = {
	__typename?: 'EmblemPagingResponse';
	items: Array<Emblem>;
	totalCount: Scalars['Int']['output'];
};

export enum EmployeeCount {
	Employees0To1 = 'Employees0To1',
	Employees2To10 = 'Employees2To10',
	Employees11To50 = 'Employees11To50',
	Employees51To200 = 'Employees51To200',
	Employees201To500 = 'Employees201To500',
	Employees501To1000 = 'Employees501To1000',
	Employees1001To5000 = 'Employees1001To5000',
	Employees5001To10000 = 'Employees5001To10000',
	EmployeesMoreThan10000 = 'EmployeesMoreThan10000',
}

export enum EmploymentLocationType {
	Hybrid = 'Hybrid',
	OnSite = 'OnSite',
	Remote = 'Remote',
}

export enum EmploymentType {
	Apprenticeship = 'Apprenticeship',
	Contract = 'Contract',
	Freelance = 'Freelance',
	FullTime = 'FullTime',
	Internship = 'Internship',
	PartTime = 'PartTime',
	Seasonal = 'Seasonal',
	SelfEmployed = 'SelfEmployed',
}

export type EntitySearch = {
	__typename?: 'EntitySearch';
	entityType: Scalars['String']['output'];
	handle?: Maybe<Scalars['String']['output']>;
	id: Scalars['ID']['output'];
};

export enum EntitySearchMode {
	All = 'All',
	Organization = 'Organization',
	User = 'User',
}

export enum EntitySearchType {
	Organization = 'Organization',
	User = 'User',
}

export type Environment = {
	__typename?: 'Environment';
	environmentName: Scalars['String']['output'];
};

export type EvolveSettings = {
	__typename?: 'EvolveSettings';
	id: Scalars['ID']['output'];
	isLegacyUiInMaintenanceMode: Scalars['Boolean']['output'];
	legacyUiInMaintenanceModeMessage: Scalars['String']['output'];
};

export type EvolveSettingsUpdate = {
	id: Scalars['ID']['input'];
	isLegacyUiInMaintenanceMode: Scalars['Boolean']['input'];
	legacyUiInMaintenanceModeMessage: Scalars['String']['input'];
};

export type File = {
	__typename?: 'File';
	file?: Maybe<FileInformation>;
	fileId?: Maybe<Scalars['ID']['output']>;
};

export enum FileAccessLevel {
	Confidential = 'Confidential',
	Public = 'Public',
	Sensitive = 'Sensitive',
}

export type FileAccessLevelChangeRequest = {
	ids: Array<Scalars['String']['input']>;
	newAccessLevel: Scalars['String']['input'];
};

export type FileDeleteRequest = {
	ids: Array<Scalars['String']['input']>;
};

export type FileDownloadInformation = {
	__typename?: 'FileDownloadInformation';
	downloadUrl: Scalars['String']['output'];
	expiresUtc?: Maybe<Scalars['Date']['output']>;
	fileInstanceId: Scalars['ID']['output'];
};

export enum FileEntityType {
	Evox = 'Evox',
	Message = 'Message',
	None = 'None',
	Organization = 'Organization',
	User = 'User',
}

export type FileInformation = {
	__typename?: 'FileInformation';
	currentInstance?: Maybe<FileInstanceInformation>;
	deleted: Scalars['Boolean']['output'];
	deletedByUserId?: Maybe<Scalars['String']['output']>;
	folder?: Maybe<FolderReference>;
	id: Scalars['ID']['output'];
	instanceCount: Scalars['Int']['output'];
	instances?: Maybe<Array<FileInstanceInformation>>;
	relatedEntityId: Scalars['String']['output'];
	relatedEntityType: FileEntityType;
};

export type FileInstanceCopyRequest = {
	accessLevel: Scalars['String']['input'];
	fileName: Scalars['String']['input'];
	folderId?: InputMaybe<Scalars['ID']['input']>;
};

export type FileInstanceInformation = {
	__typename?: 'FileInstanceInformation';
	accessLevel: FileAccessLevel;
	accessLevelImmutable: Scalars['Boolean']['output'];
	/** @deprecated Used to set allowedAccessLevelChangesList */
	allowedAccessLevelChanges: Scalars['String']['output'];
	allowedAccessLevelChangesList?: Maybe<Array<AllowableFileAccessLevels>>;
	asciiFileName: Scalars['String']['output'];
	cdnUrl?: Maybe<Scalars['String']['output']>;
	deleted: Scalars['Boolean']['output'];
	deletedByUserId?: Maybe<Scalars['String']['output']>;
	extension?: Maybe<Scalars['String']['output']>;
	fileId: Scalars['String']['output'];
	fileName: Scalars['String']['output'];
	fileSize: Scalars['Float']['output'];
	folder?: Maybe<FolderReference>;
	hasPermissionToDelete: Scalars['Boolean']['output'];
	hasPermissionToDownload: Scalars['Boolean']['output'];
	hasPermissionToUpdate: Scalars['Boolean']['output'];
	id: Scalars['ID']['output'];
	mimeType: Scalars['String']['output'];
	uploadedBy?: Maybe<Emblem>;
	uploadedUtc: Scalars['Date']['output'];
	userId: Scalars['String']['output'];
	versionNumber: Scalars['Int']['output'];
	virusStatus: VirusStatus;
	virusStatusRawResult?: Maybe<Scalars['String']['output']>;
	virusStatusUpdatedUtc?: Maybe<Scalars['Date']['output']>;
};

export type FileInstanceResponse = {
	__typename?: 'FileInstanceResponse';
	fileId: Scalars['ID']['output'];
	instances: Array<FileInstanceInformation>;
};

export type FileRenameRequest = {
	fileName: Scalars['String']['input'];
};

export type FileSetCurrentInstanceRequest = {
	fileInstanceId: Scalars['ID']['input'];
};

export type FileUploadCommitRequest = {
	accessLevel?: InputMaybe<Scalars['String']['input']>;
	fileUploadToken: Scalars['String']['input'];
	folderId?: InputMaybe<Scalars['ID']['input']>;
};

export type FileUploadRequest = {
	fileName: Scalars['String']['input'];
	fileSize: Scalars['Float']['input'];
	relatedEntityId: Scalars['String']['input'];
	relatedEntityType: FileEntityType;
	requestedAccessLevel?: InputMaybe<Scalars['String']['input']>;
	systemFileType: SystemFileType;
	updatesFileId?: InputMaybe<Scalars['String']['input']>;
};

export type FileUploadResponse = {
	__typename?: 'FileUploadResponse';
	blobUploadUrls: Array<Scalars['String']['output']>;
	expiresUtc: Scalars['Date']['output'];
	fileUploadToken: Scalars['String']['output'];
	multipartUploadId?: Maybe<Scalars['String']['output']>;
	uploadId: Scalars['ID']['output'];
};

export type FolderContents = {
	__typename?: 'FolderContents';
	files?: Maybe<Array<FileInformation>>;
	folders?: Maybe<Array<FolderReference>>;
};

export type FolderInformation = {
	__typename?: 'FolderInformation';
	contents: FolderContents;
	folderAncestors?: Maybe<Array<FolderReference>>;
	id: Scalars['ID']['output'];
	itemsCount?: Maybe<Scalars['Int']['output']>;
	name: Scalars['String']['output'];
	relatedEntityId: Scalars['String']['output'];
};

export type FolderReference = {
	__typename?: 'FolderReference';
	id: Scalars['ID']['output'];
	name: Scalars['String']['output'];
	parentFolder?: Maybe<FolderReference>;
};

export type FolderReferencesList = {
	__typename?: 'FolderReferencesList';
	folderReferences?: Maybe<Array<FolderReference>>;
};

export enum FolderSearchType {
	Any = 'Any',
	Files = 'Files',
	Folders = 'Folders',
}

export enum FoldersApiEntityType {
	Claim = 'Claim',
	Organization = 'Organization',
	User = 'User',
}

export type Follow = {
	__typename?: 'Follow';
	followedOrganizationEmblem?: Maybe<Emblem>;
	followedOrganizationId?: Maybe<Scalars['String']['output']>;
	followedUserEmblem?: Maybe<Emblem>;
	followedUserId?: Maybe<Scalars['String']['output']>;
	followingUserEmblem?: Maybe<Emblem>;
	followingUserId: Scalars['String']['output'];
	id: Scalars['ID']['output'];
};

export type GeoAddress = {
	__typename?: 'GeoAddress';
	address1?: Maybe<Scalars['String']['output']>;
	address2?: Maybe<Scalars['String']['output']>;
	adminArea1?: Maybe<AddressFieldLookup>;
	adminArea1Id?: Maybe<Scalars['String']['output']>;
	adminArea2?: Maybe<AddressFieldLookup>;
	adminArea2Id?: Maybe<Scalars['String']['output']>;
	coordinate: Location;
	countryId: Scalars['String']['output'];
	municipality?: Maybe<Scalars['String']['output']>;
	postalCode?: Maybe<Scalars['String']['output']>;
};

export type GeoAddressInput = {
	address1?: InputMaybe<Scalars['String']['input']>;
	address2?: InputMaybe<Scalars['String']['input']>;
	adminArea1Id?: InputMaybe<Scalars['String']['input']>;
	adminArea2Id?: InputMaybe<Scalars['String']['input']>;
	coordinate: LocationInput;
	countryId: Scalars['String']['input'];
	municipality?: InputMaybe<Scalars['String']['input']>;
	postalCode?: InputMaybe<Scalars['String']['input']>;
};

export type GeocodeResponse = {
	__typename?: 'GeocodeResponse';
	location: Location;
	viewport: Viewport;
};

export type GetProductsResponse = {
	__typename?: 'GetProductsResponse';
	products: Array<StripeProductInfo>;
};

export type HistoryLog = {
	__typename?: 'HistoryLog';
	changeUtc: Scalars['Date']['output'];
	changes: Array<ChangedValue>;
	historyLogId: Scalars['String']['output'];
	isAssumedIdentity: Scalars['Boolean']['output'];
	serviceId?: Maybe<Scalars['String']['output']>;
	serviceName?: Maybe<Scalars['String']['output']>;
	siteUserId?: Maybe<Scalars['String']['output']>;
	siteUserName?: Maybe<Scalars['String']['output']>;
	userId?: Maybe<Scalars['String']['output']>;
	userName?: Maybe<Scalars['String']['output']>;
};

export type HistoryLogResponse = {
	__typename?: 'HistoryLogResponse';
	entityCurrentValue: Scalars['String']['output'];
	entityId: Scalars['String']['output'];
	entityName: Scalars['String']['output'];
	historyLogs: Array<HistoryLog>;
	parent?: Maybe<ParentEntity>;
};

export enum Industry {
	Accounting = 'Accounting',
	Banking = 'Banking',
	BuildingMaterials = 'BuildingMaterials',
	CivicAndSocialOrganization = 'CivicAndSocialOrganization',
	CommercialRealEstate = 'CommercialRealEstate',
	ComputerAndNetworkSecurity = 'ComputerAndNetworkSecurity',
	ComputerSoftware = 'ComputerSoftware',
	Construction = 'Construction',
	ConsumerServices = 'ConsumerServices',
	ELearning = 'ELearning',
	EnvironmentalServices = 'EnvironmentalServices',
	EventsServices = 'EventsServices',
	FinancialServices = 'FinancialServices',
	GovernmentAdministration = 'GovernmentAdministration',
	InformationTechnologyAndServices = 'InformationTechnologyAndServices',
	Insurance = 'Insurance',
	LawPractice = 'LawPractice',
	MarketingAndAdvertising = 'MarketingAndAdvertising',
	MechanicalOrIndustrialEngineering = 'MechanicalOrIndustrialEngineering',
	NonProfitOrganizationManagement = 'NonProfitOrganizationManagement',
	ProfessionalTrainingAndCoaching = 'ProfessionalTrainingAndCoaching',
	PublicRelationsAndCommunications = 'PublicRelationsAndCommunications',
	RealEstate = 'RealEstate',
	SecurityAndInvestigations = 'SecurityAndInvestigations',
}

export type Invoice = {
	__typename?: 'Invoice';
	invoiceAmount: Scalars['Float']['output'];
	invoiceDate: Scalars['Date']['output'];
	invoiceNumber?: Maybe<Scalars['String']['output']>;
	invoicePdfUrl?: Maybe<Scalars['String']['output']>;
	isSubscription: Scalars['Boolean']['output'];
	status: InvoiceStatus;
};

export type InvoiceData = {
	__typename?: 'InvoiceData';
	autoAdvance: Scalars['Boolean']['output'];
	collectionMethod?: Maybe<Scalars['String']['output']>;
	currency?: Maybe<Scalars['String']['output']>;
	customer: Scalars['String']['output'];
	description?: Maybe<Scalars['String']['output']>;
	invoiceDate: Scalars['Date']['output'];
	invoiceItems: Array<InvoiceItemData>;
	invoiceUrl?: Maybe<Scalars['String']['output']>;
	organizationName: Scalars['String']['output'];
};

export type InvoiceDataResponse = {
	__typename?: 'InvoiceDataResponse';
	invoices: Array<InvoiceData>;
};

export type InvoiceItemData = {
	__typename?: 'InvoiceItemData';
	currency?: Maybe<Scalars['String']['output']>;
	customer: Scalars['String']['output'];
	description: Scalars['String']['output'];
	endDate?: Maybe<Scalars['Date']['output']>;
	price?: Maybe<Scalars['String']['output']>;
	quantity?: Maybe<Scalars['Float']['output']>;
	startDate?: Maybe<Scalars['Date']['output']>;
	unitAmountDecimal?: Maybe<Scalars['Float']['output']>;
};

export type InvoiceResponse = {
	__typename?: 'InvoiceResponse';
	invoices: Array<Invoice>;
	outstandingBalance: Scalars['Float']['output'];
};

export enum InvoiceStatus {
	Deleted = 'Deleted',
	Draft = 'Draft',
	Open = 'Open',
	Overdue = 'Overdue',
	Paid = 'Paid',
	Uncollectible = 'Uncollectible',
	Unknown = 'Unknown',
	Void = 'Void',
}

export type IsLinkedResponse = {
	__typename?: 'IsLinkedResponse';
	isLinked: Scalars['Boolean']['output'];
};

export enum JobFunctions {
	CarrierRepresentative = 'CarrierRepresentative',
	Employee = 'Employee',
	InsuranceAdjuster = 'InsuranceAdjuster',
	InternalAuditor = 'InternalAuditor',
	InvitedGuest = 'InvitedGuest',
	None = 'None',
	PropertyInspector = 'PropertyInspector',
	ServiceProvider = 'ServiceProvider',
	TechnicalUser = 'TechnicalUser',
}

export type JobIndustry = {
	__typename?: 'JobIndustry';
	id: Scalars['String']['output'];
	name: Scalars['String']['output'];
};

export type JobSpecialty = {
	__typename?: 'JobSpecialty';
	id: Scalars['String']['output'];
	name: Scalars['String']['output'];
};

export type JobType = {
	__typename?: 'JobType';
	id: Scalars['String']['output'];
	name: Scalars['String']['output'];
	workableCoverages: Array<Scalars['String']['output']>;
};

export enum JournalEntityType {
	DataTransformation = 'DataTransformation',
	Invoicing = 'Invoicing',
	QuickBooks = 'QuickBooks',
}

export type JournalEntry = {
	__typename?: 'JournalEntry';
	dateTimeUtc: Scalars['Date']['output'];
	id: Scalars['String']['output'];
	journalEntityId: Scalars['String']['output'];
	journalEntityName?: Maybe<Scalars['String']['output']>;
	journalEntityType: JournalEntityType;
	message?: Maybe<Scalars['String']['output']>;
	reference?: Maybe<Scalars['String']['output']>;
	severity: JournalSeverity;
};

export type JournalSearchRequest = {
	entityId?: InputMaybe<Scalars['String']['input']>;
	offset: Scalars['Float']['input'];
	pageSize: Scalars['Float']['input'];
	searchFor?: InputMaybe<Scalars['String']['input']>;
	severity?: InputMaybe<JournalSeverity>;
	sortDirection: ListSortDirection;
	sortedBy?: InputMaybe<Scalars['String']['input']>;
};

export enum JournalSeverity {
	Error = 'Error',
	Information = 'Information',
	Verbose = 'Verbose',
	Warning = 'Warning',
}

export type KeyValuePair = {
	__typename?: 'KeyValuePair';
	key: Scalars['String']['output'];
	value?: Maybe<Scalars['String']['output']>;
};

export type KeyValuePairInput = {
	key: Scalars['String']['input'];
	value?: InputMaybe<Scalars['String']['input']>;
};

export type Label = {
	__typename?: 'Label';
	colorName?: Maybe<Scalars['String']['output']>;
	entityId: Scalars['String']['output'];
	id: Scalars['ID']['output'];
	name: Scalars['String']['output'];
	parentLabelId?: Maybe<Scalars['String']['output']>;
	type: LabelType;
};

export type LabelCreateRequest = {
	colorName: Scalars['String']['input'];
	name: Scalars['String']['input'];
	parentLabelId?: InputMaybe<Scalars['String']['input']>;
};

export type LabelEditRequest = {
	colorName: Scalars['String']['input'];
	name: Scalars['String']['input'];
};

export enum LabelType {
	All = 'All',
	Custom = 'Custom',
	Inbox = 'Inbox',
	Trash = 'Trash',
}

export type LabelsResponse = {
	__typename?: 'LabelsResponse';
	labels: Array<Label>;
};

export type Language = {
	__typename?: 'Language';
	code?: Maybe<Scalars['String']['output']>;
	id: Scalars['ID']['output'];
	name?: Maybe<Scalars['String']['output']>;
};

/** Response object for getting a user's latest conversation. */
export type LatestChatConversationResponse = {
	__typename?: 'LatestChatConversationResponse';
	/** The conversation. */
	conversation?: Maybe<UserChatMessageResponse>;
};

export type LegacyClaimSummariesResult = {
	__typename?: 'LegacyClaimSummariesResult';
	claimSummaries: Array<LegacyClaimSummary>;
};

export type LegacyClaimSummary = {
	__typename?: 'LegacyClaimSummary';
	claimFileId?: Maybe<Scalars['String']['output']>;
	claimId: Scalars['Int']['output'];
	company?: Maybe<Scalars['String']['output']>;
	companyFileId?: Maybe<Scalars['String']['output']>;
	dueDate?: Maybe<Scalars['Date']['output']>;
	insuredCompany?: Maybe<Scalars['String']['output']>;
	insuredFirstName?: Maybe<Scalars['String']['output']>;
	insuredLastName?: Maybe<Scalars['String']['output']>;
	lossCity?: Maybe<Scalars['String']['output']>;
	lossState?: Maybe<Scalars['String']['output']>;
	receivedDate?: Maybe<Scalars['Date']['output']>;
};

export type LegacyClientCompany = {
	__typename?: 'LegacyClientCompany';
	companyCity?: Maybe<Scalars['String']['output']>;
	companyID: Scalars['Int']['output'];
	companyName?: Maybe<Scalars['String']['output']>;
	companyState?: Maybe<Scalars['String']['output']>;
};

export type LegacyDatabase = {
	__typename?: 'LegacyDatabase';
	name: Scalars['String']['output'];
	systemId: Scalars['String']['output'];
	systemUrl: Scalars['String']['output'];
};

export type LegacyInvitationInfoResponse = {
	__typename?: 'LegacyInvitationInfoResponse';
	adjCoLogo: Scalars['String']['output'];
	adjCoName: Scalars['String']['output'];
	systemUrl: Scalars['String']['output'];
	userName: Scalars['String']['output'];
};

export type LegacyUserAdjustmentCompanies = {
	__typename?: 'LegacyUserAdjustmentCompanies';
	adjustmentCompanies?: Maybe<Array<LegacyUserAdjustmentCompany>>;
};

export type LegacyUserAdjustmentCompaniesWithMetrics = {
	__typename?: 'LegacyUserAdjustmentCompaniesWithMetrics';
	adjustmentCompaniesWithMetrics?: Maybe<Array<LegacyUserAdjustmentCompanyWithMetrics>>;
};

export type LegacyUserAdjustmentCompany = {
	__typename?: 'LegacyUserAdjustmentCompany';
	acid: Scalars['Int']['output'];
	adjCoCity?: Maybe<Scalars['String']['output']>;
	adjCoLogo?: Maybe<Scalars['String']['output']>;
	adjCoName?: Maybe<Scalars['String']['output']>;
	adjCoState?: Maybe<Scalars['String']['output']>;
	clientCompany?: Maybe<LegacyClientCompany>;
	dbid: Scalars['Int']['output'];
	systemUrl?: Maybe<Scalars['String']['output']>;
	userEmail?: Maybe<Scalars['String']['output']>;
	userFirstName?: Maybe<Scalars['String']['output']>;
	userId: Scalars['Int']['output'];
	userLastName?: Maybe<Scalars['String']['output']>;
	userRole?: Maybe<Scalars['String']['output']>;
};

export type LegacyUserAdjustmentCompanyWithMetrics = {
	__typename?: 'LegacyUserAdjustmentCompanyWithMetrics';
	acid: Scalars['Int']['output'];
	adjCoCity?: Maybe<Scalars['String']['output']>;
	adjCoLogo?: Maybe<Scalars['String']['output']>;
	adjCoName?: Maybe<Scalars['String']['output']>;
	adjCoState?: Maybe<Scalars['String']['output']>;
	clientCompany?: Maybe<LegacyClientCompany>;
	companyClaimCount?: Maybe<Scalars['Float']['output']>;
	companyImpendingClaimCount?: Maybe<Scalars['Float']['output']>;
	companyOverdueClaimCount?: Maybe<Scalars['Float']['output']>;
	companyRecentlyReceivedClaimCount?: Maybe<Scalars['Float']['output']>;
	dbid: Scalars['Int']['output'];
	systemUrl?: Maybe<Scalars['String']['output']>;
	userClaimCount?: Maybe<Scalars['Float']['output']>;
	userEmail?: Maybe<Scalars['String']['output']>;
	userFirstName?: Maybe<Scalars['String']['output']>;
	userId: Scalars['Int']['output'];
	userImpendingClaimCount?: Maybe<Scalars['Float']['output']>;
	userLastName?: Maybe<Scalars['String']['output']>;
	userOverdueClaimCount?: Maybe<Scalars['Float']['output']>;
	userRecentlyReceivedClaimCount?: Maybe<Scalars['Float']['output']>;
	userRole?: Maybe<Scalars['String']['output']>;
};

export type LinkedAdjustmentCompanyInfo = {
	__typename?: 'LinkedAdjustmentCompanyInfo';
	acid: Scalars['Float']['output'];
	logo?: Maybe<Scalars['String']['output']>;
	name?: Maybe<Scalars['String']['output']>;
	systemUrl?: Maybe<Scalars['String']['output']>;
};

export type ListResponseOfConversationSummary = {
	__typename?: 'ListResponseOfConversationSummary';
	items: Array<ConversationSummary>;
};

export type ListResponseOfEmblem = {
	__typename?: 'ListResponseOfEmblem';
	items: Array<Emblem>;
};

export enum ListSortDirection {
	Ascending = 'Ascending',
	Descending = 'Descending',
}

export type Location = {
	__typename?: 'Location';
	latitude: Scalars['Float']['output'];
	longitude: Scalars['Float']['output'];
};

export type LocationAddress = {
	__typename?: 'LocationAddress';
	address: GeoAddress;
	addressType: Scalars['String']['output'];
	fromDate?: Maybe<Scalars['Date']['output']>;
	id: Scalars['ID']['output'];
	parentId: Scalars['String']['output'];
	toDate?: Maybe<Scalars['Date']['output']>;
};

export type LocationAddressUpdate = {
	address: GeoAddressInput;
	addressType: Scalars['String']['input'];
	fromDate?: InputMaybe<Scalars['Date']['input']>;
	toDate?: InputMaybe<Scalars['Date']['input']>;
};

export type LocationInput = {
	latitude: Scalars['Float']['input'];
	longitude: Scalars['Float']['input'];
};

export type LossType = {
	__typename?: 'LossType';
	code: Scalars['String']['output'];
	coverageId: Scalars['String']['output'];
	id: Scalars['String']['output'];
	name: Scalars['String']['output'];
};

export type Message = {
	__typename?: 'Message';
	attachmentFileIds: Array<Scalars['String']['output']>;
	attachments: Array<FileInformation>;
	createdUtc: Scalars['Date']['output'];
	creatorEntityId: Scalars['String']['output'];
	creatorEntityType: ParticipantEntityType;
	id: Scalars['ID']['output'];
	messageParticipants: Array<MessageParticipant>;
	messageText: Scalars['String']['output'];
	notificationId?: Maybe<Scalars['String']['output']>;
};

export type MessageParticipant = {
	__typename?: 'MessageParticipant';
	entityId: Scalars['String']['output'];
	entityType: ParticipantEntityType;
	firstReadUtc?: Maybe<Scalars['Date']['output']>;
	id: Scalars['ID']['output'];
};

/** Messaging draft request. */
export type MessagingDraftRequest = {
	/** The chat conversation ID, when continuing an existing conversation. Pass null to start a new conversation. */
	chatConversationId?: InputMaybe<Scalars['ID']['input']>;
	/** The ID for the conversation into which this draft will be used. If provided, conversation history will be included in requests to AI. Pass null to NOT include history. */
	commsConversationId?: InputMaybe<Scalars['ID']['input']>;
	/** The (optional) initial text of the conversation. Should only be provided when starting a new conversation. */
	initialText?: InputMaybe<Scalars['String']['input']>;
	/** The user's prompt, i.e. 'Tell them I can't make it tomorrow.' */
	prompt: Scalars['String']['input'];
};

/** Messaging draft response. */
export type MessagingDraftResponse = {
	__typename?: 'MessagingDraftResponse';
	/** The ID of the chat conversation. */
	chatConversationId: Scalars['ID']['output'];
	/** The generated draft text. */
	draftText?: Maybe<Scalars['String']['output']>;
};

export type Mutation = {
	__typename?: 'Mutation';
	billingAdHocBillingItemAdd: AdHocBillingItem;
	billingAdHocBillingItemDelete: Scalars['Boolean']['output'];
	billingAdHocBillingItemUpdate: AdHocBillingItem;
	billingOrganizationOptionsUpdate: Scalars['Boolean']['output'];
	/** Deletes a saved chat conversation. */
	chatConversationDeleteSaved: Scalars['Boolean']['output'];
	/** Saves a chat conversation so it can be reloaded and resumed in the future. */
	chatConversationSave: SavedConversation;
	/** Updates a users custom instructions. */
	chatCustomInstructionsUpdate: Scalars['Boolean']['output'];
	/** Prepares a file for use within a chat conversation. */
	chatFileRequest: UserChatFile;
	/** Adds or updates user feedback on a chat message. */
	chatMessageLeaveFeedback: UserChatMessage;
	/** Adds a user message to a new or existing chat conversation. */
	chatMessageRequest: UserChatMessageResponse;
	/** Generates a summary of the provided set of claim notes. */
	claimNotesSummaryRequest: ClaimNotesSummaryResponse;
	cognitoUserGlobalSignOut: Scalars['Boolean']['output'];
	commitFile: FileInformation;
	conversationAdd: ConversationAndSummary;
	conversationAddParticipant: ConversationAndSummary;
	conversationEmptyTrash: Scalars['Boolean']['output'];
	conversationLabelApply: ConversationAndSummary;
	conversationLabelArchive: ConversationAndSummary;
	conversationLabelCreate: Label;
	conversationLabelDelete: Scalars['Boolean']['output'];
	conversationLabelRemove: ConversationAndSummary;
	conversationLabelUpdate: Label;
	conversationMarkRead: ConversationAndSummary;
	conversationMessageAdd: ConversationAndSummary;
	conversationRemoveParticipant: ConversationAndSummary;
	conversationUpdate: ConversationAndSummary;
	deleteFile: Scalars['Boolean']['output'];
	deleteFileInstance: Scalars['Boolean']['output'];
	deleteFiles: Scalars['Boolean']['output'];
	/** Deletes a prompt clipping. */
	deletePromptClipping: Scalars['Boolean']['output'];
	deleteRelationship: Scalars['Boolean']['output'];
	fileAccessLevelChange: Array<FileInformation>;
	fileFolderChange: Array<FileInformation>;
	fileInstanceAccessLevelChange: Array<FileInstanceInformation>;
	fileInstanceCopy: FileInformation;
	fileRename: FileInformation;
	fileSetCurrentInstance: FileInformation;
	fileVirusStatusUpdate: Scalars['Boolean']['output'];
	folderCreate: FolderInformation;
	folderDelete: Scalars['Boolean']['output'];
	folderUpdate: FolderInformation;
	forgetCognitoDevices: Scalars['Boolean']['output'];
	legacyAdjustmentCompanyCreateAndLink: OrganizationCreationResponse;
	legacyAdjustmentCompanyLink: Scalars['Boolean']['output'];
	legacyInvitationAccept: Scalars['Boolean']['output'];
	/** Generates a new messaging draft based on the given conversation. */
	messagingDraftRequest: MessagingDraftResponse;
	notificationDismissAll: Scalars['Boolean']['output'];
	notificationDismissByGrouping: Scalars['Boolean']['output'];
	notificationDismissById: Scalars['Boolean']['output'];
	notificationMarkAllRead: Scalars['Boolean']['output'];
	notificationMarkReadByGrouping: Scalars['Boolean']['output'];
	notificationMarkReadById: Scalars['Boolean']['output'];
	notificationSettingsUpdate: Scalars['Boolean']['output'];
	orgAccountQuickLinkCreate: QuickLink;
	orgAccountQuickLinkDelete: Scalars['Boolean']['output'];
	orgAccountQuickLinkUpdate: QuickLink;
	organizationAboutUpdate: OrganizationProfile;
	organizationAccountActivate: Scalars['Boolean']['output'];
	organizationAccountDeactivate: Scalars['Boolean']['output'];
	organizationAccountLocationAddressAddOrUpdate: LocationAddress;
	organizationAccountLocationAddressDelete: Scalars['Boolean']['output'];
	organizationAccountUpdate: OrganizationAccount;
	organizationAccountUpdateConversationInsurance: Scalars['Boolean']['output'];
	organizationAssociateDeactivate: Scalars['Boolean']['output'];
	organizationAssociateInvitationAccept: Scalars['Boolean']['output'];
	organizationAssociateInvitationDecline: Scalars['Boolean']['output'];
	organizationAssociateInvitationDelete: Scalars['Boolean']['output'];
	organizationAssociateInvitationSend: Scalars['Boolean']['output'];
	organizationAssociateReactivate: Scalars['Boolean']['output'];
	organizationAssociateUpdate: Scalars['Boolean']['output'];
	organizationAvatarOrBannerUpdate: Emblem;
	organizationBusinessLineCreate: OrganizationProfile;
	organizationBusinessLineDelete: Scalars['Boolean']['output'];
	organizationBusinessLineUpdate: BusinessLine;
	organizationCommitFile: FileInformation;
	organizationCreate: OrganizationCreationResponse;
	organizationCreateAssociateNotification: Scalars['Boolean']['output'];
	organizationDeleteFileInstance: Scalars['Boolean']['output'];
	organizationDeleteFiles: Scalars['Boolean']['output'];
	organizationProfileUpdate: OrganizationProfile;
	organizationRepresentativeDelete: Scalars['Boolean']['output'];
	organizationRepresentativeUpsert: Representative;
	organizationRoleCreate: OrganizationRole;
	organizationRoleDelete: Scalars['Boolean']['output'];
	organizationRoleUpdate: OrganizationRole;
	organizationSetPrivate: Scalars['Boolean']['output'];
	patchOrgConfigurationSettings: OrgDashboardConfigurationResponse;
	patchUserDashboardConfigurationSettings: UserDashboardConfigurationResponse;
	/** Creates a new prompt clipping. */
	promptClippingRequest: PromptClippingResponse;
	resetMfa: Scalars['Boolean']['output'];
	seedOrgOrAncestor: Scalars['Boolean']['output'];
	setChild: Scalars['Boolean']['output'];
	socialOrganizationAcceptConnection: Connection;
	socialOrganizationCancelConnectionRequest: Scalars['Boolean']['output'];
	socialOrganizationDisconnect: Scalars['Boolean']['output'];
	socialOrganizationIgnoreConnection: Scalars['Boolean']['output'];
	socialOrganizationRequestConnection: Connection;
	socialUserAcceptConnection: Connection;
	socialUserCancelConnectionRequest: Scalars['Boolean']['output'];
	socialUserDisconnect: Scalars['Boolean']['output'];
	socialUserFollow: Scalars['Boolean']['output'];
	socialUserIgnoreConnection: Scalars['Boolean']['output'];
	socialUserRequestConnection: Connection;
	socialUserUnfollow: Scalars['Boolean']['output'];
	storeCognitoDevice: Scalars['Boolean']['output'];
	updateEvolveSettings: Scalars['Boolean']['output'];
	updateOrganizationTeamMembers: Scalars['Boolean']['output'];
	/** Updates a prompt clipping. */
	updatePromptClipping: PromptClippingResponse;
	userAccountActivationUpdate: UserAccount;
	userAccountEmergencyContactDelete: Scalars['Boolean']['output'];
	userAccountEmergencyContactUpdate: AccountEmergencyContact;
	userAccountLocationAddressAddOrUpdate: LocationAddress;
	userAccountLocationAddressDelete: Scalars['Boolean']['output'];
	userAccountPrivacyUpdate: Scalars['Boolean']['output'];
	userAccountQuickLinkCreate: QuickLink;
	userAccountQuickLinkDelete: Scalars['Boolean']['output'];
	userAccountQuickLinkUpdate: QuickLink;
	userAccountUpdate: UserAccount;
	userAvatarOrBannerUpdate: Emblem;
	userProfileCanAdjusterLicensingDelete: Scalars['Boolean']['output'];
	userProfileCanAdjusterLicensingSetManual: AdjusterLicensingSummary;
	userProfileEducationAdd: UserEducation;
	userProfileEducationDelete: Scalars['Boolean']['output'];
	userProfileEducationUpdate: UserEducation;
	userProfileExperienceCompanyAndPositionCreate: UserExperienceCompany;
	userProfileExperienceCompanyDelete: Scalars['Boolean']['output'];
	userProfileExperienceCompanyUpdate: UserExperienceCompany;
	userProfileExperiencePositionCreate: UserExperiencePosition;
	userProfileExperiencePositionDelete: Scalars['Boolean']['output'];
	userProfileExperiencePositionUpdate: UserExperiencePosition;
	userProfileSkillAdd: UserSkill;
	userProfileSkillDelete: Scalars['Boolean']['output'];
	userProfileSkillSetDisplayOrder: Scalars['Boolean']['output'];
	userProfileSkillsEndorse: Scalars['Boolean']['output'];
	userProfileSkillsEndorsementVisibility: Scalars['Boolean']['output'];
	userProfileSkillsUpdate: UserSkillPlacesUsedResponse;
	userProfileUpdate: UserProfile;
	userProfileUsaAdjusterLicensingDelete: Scalars['Boolean']['output'];
	userProfileUsaAdjusterLicensingSetManual: AdjusterLicensingSummary;
	userProfileUsaAdjusterLicensingSetNipr: AdjusterLicensingSummary;
	userRegistration: UserAccount;
	userSiteRoleAdd: SiteRole;
	userSiteRoleDelete: Scalars['Boolean']['output'];
	userSiteRoleUpdate: SiteRole;
	userSiteUserCreateSystemNotification: Scalars['Boolean']['output'];
	userSiteUserCreateTestData: Scalars['Boolean']['output'];
	userSiteUserInvitationDelete: Scalars['Boolean']['output'];
	userSiteUserInvitationResend: Scalars['Boolean']['output'];
	userSiteUserInvitationSend: SiteUserInvitation;
	userSiteUserUpdate: SiteUser;
};

export type MutationBillingAdHocBillingItemAddArgs = {
	organizationId: Scalars['String']['input'];
	update: AdHocBillingItemUpdate;
};

export type MutationBillingAdHocBillingItemDeleteArgs = {
	billingItemId: Scalars['String']['input'];
	organizationId: Scalars['String']['input'];
};

export type MutationBillingAdHocBillingItemUpdateArgs = {
	billingItemId: Scalars['String']['input'];
	organizationId: Scalars['String']['input'];
	update: AdHocBillingItemUpdate;
};

export type MutationBillingOrganizationOptionsUpdateArgs = {
	options: OrganizationBillingOptionsInput;
	organizationId: Scalars['String']['input'];
};

export type MutationChatConversationDeleteSavedArgs = {
	conversationId: Scalars['ID']['input'];
	userId: Scalars['ID']['input'];
};

export type MutationChatConversationSaveArgs = {
	conversationId: Scalars['ID']['input'];
	request: SaveConversationRequest;
	userId: Scalars['ID']['input'];
};

export type MutationChatCustomInstructionsUpdateArgs = {
	customInstructions: CustomInstructionsInput;
	userId: Scalars['ID']['input'];
};

export type MutationChatFileRequestArgs = {
	request: ChatFileRequest;
	userId: Scalars['ID']['input'];
};

export type MutationChatMessageLeaveFeedbackArgs = {
	messageId: Scalars['ID']['input'];
	request: ChatMessageFeedback;
	userId: Scalars['ID']['input'];
};

export type MutationChatMessageRequestArgs = {
	request: UserChatMessageRequest;
	userId: Scalars['ID']['input'];
};

export type MutationClaimNotesSummaryRequestArgs = {
	request: ClaimNotesSummaryRequest;
};

export type MutationCognitoUserGlobalSignOutArgs = {
	userId: Scalars['ID']['input'];
};

export type MutationCommitFileArgs = {
	entityId: Scalars['String']['input'];
	entityType: FoldersApiEntityType;
	request: FileUploadCommitRequest;
};

export type MutationConversationAddArgs = {
	entityId: Scalars['String']['input'];
	entityType: ConversationApiEntityType;
	metadata?: InputMaybe<Array<KeyValuePairInput>>;
	request: NewConversationRequest;
};

export type MutationConversationAddParticipantArgs = {
	conversationId: Scalars['String']['input'];
	entityId: Scalars['String']['input'];
	entityType: ConversationApiEntityType;
	metadata?: InputMaybe<Array<KeyValuePairInput>>;
	request: NewParticipantOptions;
};

export type MutationConversationEmptyTrashArgs = {
	entityId: Scalars['String']['input'];
	entityType: ConversationApiEntityType;
	metadata?: InputMaybe<Array<KeyValuePairInput>>;
};

export type MutationConversationLabelApplyArgs = {
	conversationId: Scalars['String']['input'];
	entityId: Scalars['String']['input'];
	entityType: ConversationApiEntityType;
	labelId: Scalars['String']['input'];
	metadata?: InputMaybe<Array<KeyValuePairInput>>;
};

export type MutationConversationLabelArchiveArgs = {
	conversationId: Scalars['String']['input'];
	entityId: Scalars['String']['input'];
	entityType: ConversationApiEntityType;
	metadata?: InputMaybe<Array<KeyValuePairInput>>;
};

export type MutationConversationLabelCreateArgs = {
	entityId: Scalars['String']['input'];
	entityType: ConversationApiEntityType;
	labelRequest: LabelCreateRequest;
	metadata?: InputMaybe<Array<KeyValuePairInput>>;
};

export type MutationConversationLabelDeleteArgs = {
	entityId: Scalars['String']['input'];
	entityType: ConversationApiEntityType;
	labelId: Scalars['String']['input'];
	metadata?: InputMaybe<Array<KeyValuePairInput>>;
};

export type MutationConversationLabelRemoveArgs = {
	conversationId: Scalars['String']['input'];
	entityId: Scalars['String']['input'];
	entityType: ConversationApiEntityType;
	labelId: Scalars['String']['input'];
	metadata?: InputMaybe<Array<KeyValuePairInput>>;
};

export type MutationConversationLabelUpdateArgs = {
	entityId: Scalars['String']['input'];
	entityType: ConversationApiEntityType;
	labelId: Scalars['String']['input'];
	labelRequest: LabelEditRequest;
	metadata?: InputMaybe<Array<KeyValuePairInput>>;
};

export type MutationConversationMarkReadArgs = {
	conversationId: Scalars['String']['input'];
	entityId: Scalars['String']['input'];
	entityType: ConversationApiEntityType;
	metadata?: InputMaybe<Array<KeyValuePairInput>>;
};

export type MutationConversationMessageAddArgs = {
	conversationId: Scalars['String']['input'];
	entityId: Scalars['String']['input'];
	entityType: ConversationApiEntityType;
	metadata?: InputMaybe<Array<KeyValuePairInput>>;
	request: NewMessageRequest;
};

export type MutationConversationRemoveParticipantArgs = {
	conversationId: Scalars['String']['input'];
	entityId: Scalars['String']['input'];
	entityType: ConversationApiEntityType;
	metadata?: InputMaybe<Array<KeyValuePairInput>>;
	request: Participant;
};

export type MutationConversationUpdateArgs = {
	conversationId: Scalars['String']['input'];
	entityId: Scalars['String']['input'];
	entityType: ConversationApiEntityType;
	metadata?: InputMaybe<Array<KeyValuePairInput>>;
	request: UpdateConversationRequest;
};

export type MutationDeleteFileArgs = {
	entityId: Scalars['String']['input'];
	entityType: FoldersApiEntityType;
	request: FileDeleteRequest;
};

export type MutationDeleteFileInstanceArgs = {
	entityId: Scalars['String']['input'];
	entityType: FoldersApiEntityType;
	request: FileDeleteRequest;
};

export type MutationDeleteFilesArgs = {
	entityId: Scalars['String']['input'];
	entityType: FoldersApiEntityType;
	request: FileDeleteRequest;
};

export type MutationDeletePromptClippingArgs = {
	clippingId: Scalars['ID']['input'];
	userId: Scalars['ID']['input'];
};

export type MutationDeleteRelationshipArgs = {
	childOrgId: Scalars['ID']['input'];
	parentOrgId: Scalars['ID']['input'];
};

export type MutationFileAccessLevelChangeArgs = {
	request: FileAccessLevelChangeRequest;
};

export type MutationFileFolderChangeArgs = {
	request: ChangeFileFolderRequest;
};

export type MutationFileInstanceAccessLevelChangeArgs = {
	request: FileAccessLevelChangeRequest;
};

export type MutationFileInstanceCopyArgs = {
	fileInstanceId: Scalars['String']['input'];
	request: FileInstanceCopyRequest;
};

export type MutationFileRenameArgs = {
	fileId: Scalars['String']['input'];
	request: FileRenameRequest;
};

export type MutationFileSetCurrentInstanceArgs = {
	fileId: Scalars['String']['input'];
	request: FileSetCurrentInstanceRequest;
};

export type MutationFileVirusStatusUpdateArgs = {
	result: VirusScanResult;
};

export type MutationFolderCreateArgs = {
	entityId: Scalars['String']['input'];
	entityType: FoldersApiEntityType;
	request: UpsertFolderRequest;
};

export type MutationFolderDeleteArgs = {
	entityId: Scalars['String']['input'];
	entityType: FoldersApiEntityType;
	folderId: Scalars['String']['input'];
};

export type MutationFolderUpdateArgs = {
	entityId: Scalars['String']['input'];
	entityType: FoldersApiEntityType;
	folderId: Scalars['String']['input'];
	request: UpsertFolderRequest;
};

export type MutationForgetCognitoDevicesArgs = {
	userId: Scalars['ID']['input'];
};

export type MutationLegacyAdjustmentCompanyCreateAndLinkArgs = {
	request: OrganizationCreateAndLinkRequest;
};

export type MutationLegacyAdjustmentCompanyLinkArgs = {
	orgId: Scalars['ID']['input'];
	request: OrganizationLinkRequest;
};

export type MutationLegacyInvitationAcceptArgs = {
	invitationId: Scalars['ID']['input'];
};

export type MutationMessagingDraftRequestArgs = {
	entityId: Scalars['String']['input'];
	entityType: ConversationApiEntityType;
	request: MessagingDraftRequest;
};

export type MutationNotificationDismissAllArgs = {
	types?: InputMaybe<Array<NotificationType>>;
};

export type MutationNotificationDismissByGroupingArgs = {
	inAppText: Scalars['String']['input'];
	notificationType: NotificationType;
	relatedEntityId: Scalars['ID']['input'];
};

export type MutationNotificationDismissByIdArgs = {
	notificationId: Scalars['ID']['input'];
};

export type MutationNotificationMarkAllReadArgs = {
	types?: InputMaybe<Array<NotificationType>>;
};

export type MutationNotificationMarkReadByGroupingArgs = {
	inAppText: Scalars['String']['input'];
	notificationType: NotificationType;
	relatedEntityId: Scalars['ID']['input'];
};

export type MutationNotificationMarkReadByIdArgs = {
	notificationId: Scalars['ID']['input'];
};

export type MutationNotificationSettingsUpdateArgs = {
	update: NotificationSettingsInput;
	userId: Scalars['ID']['input'];
};

export type MutationOrgAccountQuickLinkCreateArgs = {
	orgId: Scalars['ID']['input'];
	request: QuickLinkCreate;
};

export type MutationOrgAccountQuickLinkDeleteArgs = {
	orgId: Scalars['ID']['input'];
	quickLinkId: Scalars['ID']['input'];
};

export type MutationOrgAccountQuickLinkUpdateArgs = {
	orgId: Scalars['ID']['input'];
	quickLinkId: Scalars['ID']['input'];
	request: QuickLinkPatch;
};

export type MutationOrganizationAboutUpdateArgs = {
	organizationAboutUpdate: OrganizationAboutUpdate;
	organizationId: Scalars['ID']['input'];
};

export type MutationOrganizationAccountActivateArgs = {
	organizationId: Scalars['ID']['input'];
};

export type MutationOrganizationAccountDeactivateArgs = {
	organizationId: Scalars['ID']['input'];
};

export type MutationOrganizationAccountLocationAddressAddOrUpdateArgs = {
	locationAddressId?: InputMaybe<Scalars['ID']['input']>;
	organizationId: Scalars['ID']['input'];
	update: LocationAddressUpdate;
};

export type MutationOrganizationAccountLocationAddressDeleteArgs = {
	locationAddressId: Scalars['ID']['input'];
	organizationId: Scalars['ID']['input'];
};

export type MutationOrganizationAccountUpdateArgs = {
	organizationAccount: OrganizationAccountUpdate;
	organizationId: Scalars['ID']['input'];
};

export type MutationOrganizationAccountUpdateConversationInsuranceArgs = {
	organizationId: Scalars['ID']['input'];
	request: ConversationInsuranceInput;
};

export type MutationOrganizationAssociateDeactivateArgs = {
	associateId: Scalars['ID']['input'];
	organizationId: Scalars['ID']['input'];
};

export type MutationOrganizationAssociateInvitationAcceptArgs = {
	invitationId: Scalars['String']['input'];
};

export type MutationOrganizationAssociateInvitationDeclineArgs = {
	invitationId: Scalars['String']['input'];
};

export type MutationOrganizationAssociateInvitationDeleteArgs = {
	invitationId: Scalars['ID']['input'];
	organizationId: Scalars['ID']['input'];
};

export type MutationOrganizationAssociateInvitationSendArgs = {
	inviteRequest: AssociateInvitationRequest;
	organizationId: Scalars['ID']['input'];
};

export type MutationOrganizationAssociateReactivateArgs = {
	associateId: Scalars['ID']['input'];
	organizationId: Scalars['ID']['input'];
	organizationRoleId: Scalars['ID']['input'];
};

export type MutationOrganizationAssociateUpdateArgs = {
	associateId: Scalars['ID']['input'];
	organizationId: Scalars['ID']['input'];
	update: AssociateUpdate;
};

export type MutationOrganizationAvatarOrBannerUpdateArgs = {
	avatarUploadToken?: InputMaybe<Scalars['String']['input']>;
	bannerUploadToken?: InputMaybe<Scalars['String']['input']>;
	organizationId: Scalars['ID']['input'];
};

export type MutationOrganizationBusinessLineCreateArgs = {
	businessLineCreate: BusinessLineUpdate;
	organizationId: Scalars['ID']['input'];
};

export type MutationOrganizationBusinessLineDeleteArgs = {
	lineId: Scalars['ID']['input'];
	organizationId: Scalars['ID']['input'];
};

export type MutationOrganizationBusinessLineUpdateArgs = {
	businessLineCreate: BusinessLineUpdate;
	lineId: Scalars['ID']['input'];
	organizationId: Scalars['ID']['input'];
};

export type MutationOrganizationCommitFileArgs = {
	orgId: Scalars['String']['input'];
	request: FileUploadCommitRequest;
};

export type MutationOrganizationCreateArgs = {
	organizationCreation: OrganizationCreation;
};

export type MutationOrganizationCreateAssociateNotificationArgs = {
	organizationId: Scalars['String']['input'];
	request: OrganizationNotificationRequest;
};

export type MutationOrganizationDeleteFileInstanceArgs = {
	orgId: Scalars['String']['input'];
	request: FileDeleteRequest;
};

export type MutationOrganizationDeleteFilesArgs = {
	orgId: Scalars['String']['input'];
	request: FileDeleteRequest;
};

export type MutationOrganizationProfileUpdateArgs = {
	organizationId: Scalars['ID']['input'];
	organizationProfileUpdate: OrganizationProfileUpdate;
};

export type MutationOrganizationRepresentativeDeleteArgs = {
	organizationId: Scalars['ID']['input'];
	representativeId: Scalars['ID']['input'];
};

export type MutationOrganizationRepresentativeUpsertArgs = {
	organizationId: Scalars['ID']['input'];
	representativeId?: InputMaybe<Scalars['ID']['input']>;
	update: RepresentativeUpdate;
};

export type MutationOrganizationRoleCreateArgs = {
	organizationId: Scalars['ID']['input'];
	role: OrganizationRoleUpdate;
};

export type MutationOrganizationRoleDeleteArgs = {
	organizationId: Scalars['ID']['input'];
	roleId: Scalars['ID']['input'];
};

export type MutationOrganizationRoleUpdateArgs = {
	organizationId: Scalars['ID']['input'];
	role: OrganizationRoleUpdate;
	roleId: Scalars['ID']['input'];
};

export type MutationOrganizationSetPrivateArgs = {
	orgId: Scalars['ID']['input'];
	private: Scalars['Boolean']['input'];
};

export type MutationPatchOrgConfigurationSettingsArgs = {
	orgId: Scalars['ID']['input'];
	patch: OrgDashboardConfigurationPatch;
};

export type MutationPatchUserDashboardConfigurationSettingsArgs = {
	patch: UserDashboardConfigurationPatch;
	userId: Scalars['ID']['input'];
};

export type MutationPromptClippingRequestArgs = {
	request: PromptClippingRequest;
	userId: Scalars['ID']['input'];
};

export type MutationResetMfaArgs = {
	userId: Scalars['ID']['input'];
};

export type MutationSeedOrgOrAncestorArgs = {
	orgToSeedId: Scalars['ID']['input'];
	sourceOrgId: Scalars['ID']['input'];
};

export type MutationSetChildArgs = {
	childOrgId: Scalars['ID']['input'];
	parentOrgId: Scalars['ID']['input'];
};

export type MutationSocialOrganizationAcceptConnectionArgs = {
	connectionId: Scalars['ID']['input'];
	organizationId: Scalars['ID']['input'];
};

export type MutationSocialOrganizationCancelConnectionRequestArgs = {
	connectionId: Scalars['ID']['input'];
	organizationId: Scalars['ID']['input'];
};

export type MutationSocialOrganizationDisconnectArgs = {
	connectionId: Scalars['ID']['input'];
	organizationId: Scalars['ID']['input'];
};

export type MutationSocialOrganizationIgnoreConnectionArgs = {
	connectionId: Scalars['ID']['input'];
	organizationId: Scalars['ID']['input'];
};

export type MutationSocialOrganizationRequestConnectionArgs = {
	organizationId: Scalars['ID']['input'];
	userOrOrganizationId: Scalars['ID']['input'];
};

export type MutationSocialUserAcceptConnectionArgs = {
	connectionId: Scalars['ID']['input'];
	userId: Scalars['ID']['input'];
};

export type MutationSocialUserCancelConnectionRequestArgs = {
	connectionId: Scalars['ID']['input'];
	userId: Scalars['ID']['input'];
};

export type MutationSocialUserDisconnectArgs = {
	connectionId: Scalars['ID']['input'];
	userId: Scalars['ID']['input'];
};

export type MutationSocialUserFollowArgs = {
	userId: Scalars['ID']['input'];
	userOrOrganizationId: Scalars['ID']['input'];
};

export type MutationSocialUserIgnoreConnectionArgs = {
	connectionId: Scalars['ID']['input'];
	userId: Scalars['ID']['input'];
};

export type MutationSocialUserRequestConnectionArgs = {
	userId: Scalars['ID']['input'];
	userOrOrganizationId: Scalars['ID']['input'];
};

export type MutationSocialUserUnfollowArgs = {
	userId: Scalars['ID']['input'];
	userOrOrganizationId: Scalars['ID']['input'];
};

export type MutationStoreCognitoDeviceArgs = {
	storeCognitoDeviceRequest: StoreCognitoDeviceRequest;
};

export type MutationUpdateEvolveSettingsArgs = {
	settingsId: Scalars['ID']['input'];
	update: EvolveSettingsUpdate;
};

export type MutationUpdateOrganizationTeamMembersArgs = {
	organizationId: Scalars['ID']['input'];
	update: TeamMembersUpdate;
};

export type MutationUpdatePromptClippingArgs = {
	clippingId: Scalars['ID']['input'];
	request: PromptClippingRequest;
	userId: Scalars['ID']['input'];
};

export type MutationUserAccountActivationUpdateArgs = {
	operation: ActivationOperation;
	userId: Scalars['ID']['input'];
};

export type MutationUserAccountEmergencyContactDeleteArgs = {
	userId: Scalars['ID']['input'];
};

export type MutationUserAccountEmergencyContactUpdateArgs = {
	emergencyContactUpdate: AccountEmergencyContactUpdate;
	userId: Scalars['ID']['input'];
};

export type MutationUserAccountLocationAddressAddOrUpdateArgs = {
	locationAddressId?: InputMaybe<Scalars['String']['input']>;
	update: LocationAddressUpdate;
	userId: Scalars['ID']['input'];
};

export type MutationUserAccountLocationAddressDeleteArgs = {
	locationAddressId: Scalars['ID']['input'];
	userId: Scalars['ID']['input'];
};

export type MutationUserAccountPrivacyUpdateArgs = {
	isPrivate: Scalars['Boolean']['input'];
	userId: Scalars['ID']['input'];
};

export type MutationUserAccountQuickLinkCreateArgs = {
	request: QuickLinkCreate;
	userId: Scalars['ID']['input'];
};

export type MutationUserAccountQuickLinkDeleteArgs = {
	quickLinkId: Scalars['ID']['input'];
	userId: Scalars['ID']['input'];
};

export type MutationUserAccountQuickLinkUpdateArgs = {
	quickLinkId: Scalars['ID']['input'];
	request: QuickLinkPatch;
	userId: Scalars['ID']['input'];
};

export type MutationUserAccountUpdateArgs = {
	accountUpdate: UserAccountUpdate;
	userId: Scalars['ID']['input'];
};

export type MutationUserAvatarOrBannerUpdateArgs = {
	avatarUploadToken?: InputMaybe<Scalars['String']['input']>;
	bannerUploadToken?: InputMaybe<Scalars['String']['input']>;
	userId: Scalars['ID']['input'];
};

export type MutationUserProfileCanAdjusterLicensingDeleteArgs = {
	userId: Scalars['ID']['input'];
};

export type MutationUserProfileCanAdjusterLicensingSetManualArgs = {
	canadianLicensing: CanAdjusterLicensingInput;
	userId: Scalars['ID']['input'];
};

export type MutationUserProfileEducationAddArgs = {
	update: UserEducationUpdate;
	userId: Scalars['ID']['input'];
};

export type MutationUserProfileEducationDeleteArgs = {
	userEducationId: Scalars['ID']['input'];
	userId: Scalars['ID']['input'];
};

export type MutationUserProfileEducationUpdateArgs = {
	update: UserEducationUpdate;
	userEducationId: Scalars['ID']['input'];
	userId: Scalars['ID']['input'];
};

export type MutationUserProfileExperienceCompanyAndPositionCreateArgs = {
	request: UserExperienceCompanyAndPositionCreation;
	userId: Scalars['ID']['input'];
};

export type MutationUserProfileExperienceCompanyDeleteArgs = {
	userExperienceCompanyId: Scalars['ID']['input'];
	userId: Scalars['ID']['input'];
};

export type MutationUserProfileExperienceCompanyUpdateArgs = {
	request: UserExperienceCompanyUpdate;
	userExperienceCompanyId: Scalars['ID']['input'];
	userId: Scalars['ID']['input'];
};

export type MutationUserProfileExperiencePositionCreateArgs = {
	request: UserExperiencePositionUpdate;
	userExperienceCompanyId: Scalars['ID']['input'];
	userId: Scalars['ID']['input'];
};

export type MutationUserProfileExperiencePositionDeleteArgs = {
	userExperienceCompanyId: Scalars['ID']['input'];
	userExperiencePositionId: Scalars['ID']['input'];
	userId: Scalars['ID']['input'];
};

export type MutationUserProfileExperiencePositionUpdateArgs = {
	request: UserExperiencePositionUpdate;
	userExperienceCompanyId: Scalars['ID']['input'];
	userExperiencePositionId: Scalars['ID']['input'];
	userId: Scalars['ID']['input'];
};

export type MutationUserProfileSkillAddArgs = {
	request: UserSkillCreate;
	userId: Scalars['ID']['input'];
};

export type MutationUserProfileSkillDeleteArgs = {
	userId: Scalars['ID']['input'];
	userSkillId: Scalars['ID']['input'];
};

export type MutationUserProfileSkillSetDisplayOrderArgs = {
	displayOrders: Array<UserSkillDisplayOrder>;
	userId: Scalars['ID']['input'];
};

export type MutationUserProfileSkillsEndorseArgs = {
	endorse: Scalars['Boolean']['input'];
	userId: Scalars['ID']['input'];
	userSkillId: Scalars['ID']['input'];
};

export type MutationUserProfileSkillsEndorsementVisibilityArgs = {
	endorsementId: Scalars['String']['input'];
	userId: Scalars['ID']['input'];
	userSkillId: Scalars['ID']['input'];
	visible: Scalars['Boolean']['input'];
};

export type MutationUserProfileSkillsUpdateArgs = {
	request: UserSkillPlacesUsedUpdateRequest;
	userId: Scalars['ID']['input'];
	userSkillId: Scalars['ID']['input'];
};

export type MutationUserProfileUpdateArgs = {
	update: UserProfileUpdate;
	userId: Scalars['ID']['input'];
};

export type MutationUserProfileUsaAdjusterLicensingDeleteArgs = {
	userId: Scalars['ID']['input'];
};

export type MutationUserProfileUsaAdjusterLicensingSetManualArgs = {
	usLicensing: UsaAdjusterLicensingInput;
	userId: Scalars['ID']['input'];
};

export type MutationUserProfileUsaAdjusterLicensingSetNiprArgs = {
	npnNumber: Scalars['Float']['input'];
	userId: Scalars['ID']['input'];
};

export type MutationUserRegistrationArgs = {
	registration: UserRegistration;
	userId: Scalars['ID']['input'];
};

export type MutationUserSiteRoleAddArgs = {
	siteRoleUpdate: SiteRoleUpdate;
};

export type MutationUserSiteRoleDeleteArgs = {
	id: Scalars['String']['input'];
};

export type MutationUserSiteRoleUpdateArgs = {
	id: Scalars['String']['input'];
	siteRoleUpdate: SiteRoleUpdate;
};

export type MutationUserSiteUserCreateSystemNotificationArgs = {
	request: SystemNotificationRequest;
};

export type MutationUserSiteUserInvitationDeleteArgs = {
	invitationId: Scalars['String']['input'];
};

export type MutationUserSiteUserInvitationResendArgs = {
	invitationId: Scalars['String']['input'];
};

export type MutationUserSiteUserInvitationSendArgs = {
	siteUserInvitationRequest: SiteUserInvitationRequest;
};

export type MutationUserSiteUserUpdateArgs = {
	siteUserId: Scalars['ID']['input'];
	update: SiteUserUpdate;
};

export type NewConversationRequest = {
	attachmentUploadTokens?: InputMaybe<Array<Scalars['String']['input']>>;
	messageText: Scalars['String']['input'];
	participants: Array<Participant>;
	requestedMessageId?: InputMaybe<Scalars['ID']['input']>;
	subject: Scalars['String']['input'];
};

export type NewMessageRequest = {
	attachmentUploadTokens?: InputMaybe<Array<Scalars['String']['input']>>;
	messageText: Scalars['String']['input'];
	requestedMessageId?: InputMaybe<Scalars['ID']['input']>;
};

export type NewParticipantOptions = {
	entityId: Scalars['String']['input'];
	entityType: ParticipantEntityType;
	historyShareFromUtc?: InputMaybe<Scalars['Date']['input']>;
	historyType: ParticipantHistoryType;
};

export type Notification = {
	__typename?: 'Notification';
	associatedUrl?: Maybe<Scalars['String']['output']>;
	createdUtc: Scalars['Date']['output'];
	displayText: Scalars['String']['output'];
	id: Scalars['ID']['output'];
	readCount: Scalars['Float']['output'];
	recipientUserId: Scalars['String']['output'];
	relatedEntityEmblem?: Maybe<Emblem>;
	relatedEntityId: Scalars['String']['output'];
	relatedEntityType: RelatedEntityType;
	state: NotificationState;
	targetEntityId: Scalars['String']['output'];
	type: NotificationType;
	unreadCount: Scalars['Float']['output'];
};

export type NotificationDetail = {
	__typename?: 'NotificationDetail';
	createdUtc: Scalars['Date']['output'];
	emailPlainTextBody: Scalars['String']['output'];
	emailSubject: Scalars['String']['output'];
	id: Scalars['String']['output'];
	inAppText: Scalars['String']['output'];
	notificationType: NotificationType;
	numUsersFailed: Scalars['Float']['output'];
	numUsersSending: Scalars['Float']['output'];
	numUsersSent: Scalars['Float']['output'];
	smsText: Scalars['String']['output'];
};

export type NotificationPagingResponse = {
	__typename?: 'NotificationPagingResponse';
	items: Array<Notification>;
	totalCount: Scalars['Int']['output'];
	totalUnseenCount: Scalars['Int']['output'];
};

export type NotificationSetting = {
	__typename?: 'NotificationSetting';
	email: Scalars['Boolean']['output'];
	emailDigestDaily: Scalars['Boolean']['output'];
	emailDigestHourly: Scalars['Boolean']['output'];
	inApp: Scalars['Boolean']['output'];
	notificationType: NotificationType;
	sms: Scalars['Boolean']['output'];
};

export type NotificationSettingDefault = {
	__typename?: 'NotificationSettingDefault';
	allowedTransportsList: Array<AllowedTransports>;
	description: Scalars['String']['output'];
	displayName: Scalars['String']['output'];
	displayOrder: Scalars['Float']['output'];
	email: Scalars['Boolean']['output'];
	emailDigestDaily: Scalars['Boolean']['output'];
	emailDigestHourly: Scalars['Boolean']['output'];
	groupName: Scalars['String']['output'];
	inApp: Scalars['Boolean']['output'];
	notificationType: NotificationType;
	requiresAtLeastOne: Scalars['Boolean']['output'];
	sms: Scalars['Boolean']['output'];
};

export type NotificationSettingDefaultGroupResponse = {
	__typename?: 'NotificationSettingDefaultGroupResponse';
	groupName: Scalars['String']['output'];
	items: Array<NotificationSettingDefault>;
};

export type NotificationSettingInput = {
	email: Scalars['Boolean']['input'];
	emailDigestDaily: Scalars['Boolean']['input'];
	emailDigestHourly: Scalars['Boolean']['input'];
	inApp: Scalars['Boolean']['input'];
	notificationType: NotificationType;
	sms: Scalars['Boolean']['input'];
};

export type NotificationSettings = {
	__typename?: 'NotificationSettings';
	settings: Array<NotificationSetting>;
};

export type NotificationSettingsInput = {
	settings: Array<NotificationSettingInput>;
};

export enum NotificationState {
	New = 'New',
	Read = 'Read',
	Seen = 'Seen',
}

export type NotificationSummary = {
	__typename?: 'NotificationSummary';
	createdUtc: Scalars['Date']['output'];
	emailPlainTextBody: Scalars['String']['output'];
	emailSubject: Scalars['String']['output'];
	id: Scalars['String']['output'];
	inAppText: Scalars['String']['output'];
	notificationType: NotificationType;
	smsText: Scalars['String']['output'];
};

export enum NotificationType {
	AssociateInvite = 'AssociateInvite',
	AssociateNotification = 'AssociateNotification',
	BillingUpdate = 'BillingUpdate',
	ConnectionAccepted = 'ConnectionAccepted',
	ConnectionRequested = 'ConnectionRequested',
	MessageReceived = 'MessageReceived',
	SiteUserInvitation = 'SiteUserInvitation',
	SystemNotification = 'SystemNotification',
}

export type OperationPermission = {
	__typename?: 'OperationPermission';
	operationType: Scalars['String']['output'];
	permissionKey: Scalars['String']['output'];
};

export type OrgBadgeCountResponse = {
	__typename?: 'OrgBadgeCountResponse';
	conversationsBadgeCount: Scalars['Float']['output'];
	inboundRequestsBadgeCount: Scalars['Float']['output'];
};

export type OrgDashboardConfigurationPatch = {
	primaryColor: Scalars['String']['input'];
	secondaryColor: Scalars['String']['input'];
	subTitle: Scalars['String']['input'];
	title: Scalars['String']['input'];
};

export type OrgDashboardConfigurationResponse = {
	__typename?: 'OrgDashboardConfigurationResponse';
	id: Scalars['ID']['output'];
	primaryColor: Scalars['String']['output'];
	secondaryColor: Scalars['String']['output'];
	subTitle: Scalars['String']['output'];
	title: Scalars['String']['output'];
};

export type OrgSearchResult = {
	__typename?: 'OrgSearchResult';
	deactivated?: Maybe<Scalars['Boolean']['output']>;
	displayLocation?: Maybe<Scalars['String']['output']>;
	id?: Maybe<Scalars['String']['output']>;
	legalName?: Maybe<Scalars['String']['output']>;
	organizationEmblem?: Maybe<Emblem>;
	systemEmailAddress?: Maybe<Scalars['String']['output']>;
};

export type OrganizationAboutUpdate = {
	about?: InputMaybe<Scalars['String']['input']>;
	displayPhoneNumber?: InputMaybe<PhoneNumberInput>;
	industry?: InputMaybe<Scalars['String']['input']>;
	numberOfEmployees?: InputMaybe<Scalars['String']['input']>;
	websiteUrl?: InputMaybe<Scalars['String']['input']>;
	yearFounded?: InputMaybe<Scalars['Float']['input']>;
};

export type OrganizationAccount = {
	__typename?: 'OrganizationAccount';
	avatarFile?: Maybe<File>;
	bannerFile?: Maybe<File>;
	deactivated: Scalars['Boolean']['output'];
	displayName: Scalars['String']['output'];
	handle: Scalars['String']['output'];
	id: Scalars['ID']['output'];
	lastUpdatedUtc: Scalars['Date']['output'];
	legalName: Scalars['String']['output'];
	mainPhoneNumber: PhoneNumber;
	private: Scalars['Boolean']['output'];
	quickLinks?: Maybe<Array<QuickLink>>;
	systemEmailAddress: Scalars['String']['output'];
};

export type OrganizationAccountPagingResponse = {
	__typename?: 'OrganizationAccountPagingResponse';
	items: Array<OrganizationAccount>;
	totalCount: Scalars['Int']['output'];
};

export type OrganizationAccountUpdate = {
	avatarUploadToken?: InputMaybe<Scalars['String']['input']>;
	bannerUploadToken?: InputMaybe<Scalars['String']['input']>;
	displayName: Scalars['String']['input'];
	handle: Scalars['String']['input'];
	legalName: Scalars['String']['input'];
	mainPhoneNumber: PhoneNumberInput;
	systemEmailAddress: Scalars['String']['input'];
};

export type OrganizationAncestor = {
	__typename?: 'OrganizationAncestor';
	ancestorLevel: Scalars['Int']['output'];
	emblem?: Maybe<Emblem>;
	organizationId: Scalars['ID']['output'];
};

export type OrganizationAncestorsResponse = {
	__typename?: 'OrganizationAncestorsResponse';
	ancestorToSeedId?: Maybe<Scalars['ID']['output']>;
	ancestors?: Maybe<Array<OrganizationAncestor>>;
	emblem: Emblem;
	organizationId: Scalars['ID']['output'];
};

export type OrganizationBillingOptions = {
	__typename?: 'OrganizationBillingOptions';
	billChildrenForUsage: Scalars['Boolean']['output'];
	chargeAutomatically: Scalars['Boolean']['output'];
	createInvoicesAsDrafts: Scalars['Boolean']['output'];
	notBillable: Scalars['Boolean']['output'];
};

export type OrganizationBillingOptionsInput = {
	billChildrenForUsage: Scalars['Boolean']['input'];
	chargeAutomatically: Scalars['Boolean']['input'];
	createInvoicesAsDrafts: Scalars['Boolean']['input'];
	notBillable: Scalars['Boolean']['input'];
};

export type OrganizationBillingSummary = {
	__typename?: 'OrganizationBillingSummary';
	amountBilled: Scalars['Float']['output'];
	balanceDue: Scalars['Float']['output'];
	organizationHandle?: Maybe<Scalars['String']['output']>;
	organizationName?: Maybe<Scalars['String']['output']>;
	requiresAttention: Scalars['Boolean']['output'];
	status: InvoiceStatus;
	stripeCustomerUrl?: Maybe<Scalars['String']['output']>;
};

export type OrganizationBillingSummaryResponse = {
	__typename?: 'OrganizationBillingSummaryResponse';
	invoiceSummaries: Array<OrganizationBillingSummary>;
	totalAmountBilled: Scalars['Float']['output'];
	totalBalanceDue: Scalars['Float']['output'];
};

export type OrganizationCreateAndLinkRequest = {
	acid: Scalars['Float']['input'];
	displayName: Scalars['String']['input'];
	legalName: Scalars['String']['input'];
	mailingAddress: AddressInput;
	mainPhoneNumber: PhoneNumberInput;
	systemEmailAddress: Scalars['String']['input'];
	systemId: Scalars['Float']['input'];
};

export type OrganizationCreation = {
	displayName: Scalars['String']['input'];
	legalName: Scalars['String']['input'];
	mailingAddress: AddressInput;
	mainPhoneNumber: PhoneNumberInput;
	systemEmailAddress: Scalars['String']['input'];
};

export type OrganizationCreationResponse = {
	__typename?: 'OrganizationCreationResponse';
	handle: Scalars['String']['output'];
};

export type OrganizationImmediateFamilyResponse = {
	__typename?: 'OrganizationImmediateFamilyResponse';
	childEmblems?: Maybe<Array<Emblem>>;
	childOrganizationIds?: Maybe<Array<Scalars['ID']['output']>>;
	emblem: Emblem;
	organizationId: Scalars['ID']['output'];
	parentEmblem?: Maybe<Emblem>;
	parentOrganizationId?: Maybe<Scalars['ID']['output']>;
};

export type OrganizationLinkRequest = {
	acid: Scalars['Float']['input'];
	systemId: Scalars['Float']['input'];
};

export enum OrganizationNotificationAudience {
	Administrators = 'Administrators',
	AllAssociates = 'AllAssociates',
	None = 'None',
}

export type OrganizationNotificationRequest = {
	audience: Array<OrganizationNotificationAudience>;
	emailHtmlBody: Scalars['String']['input'];
	emailSubject: Scalars['String']['input'];
	inAppText: Scalars['String']['input'];
	smsSendAsBulk: Scalars['Boolean']['input'];
	smsText: Scalars['String']['input'];
};

export type OrganizationProfile = {
	__typename?: 'OrganizationProfile';
	about?: Maybe<Scalars['String']['output']>;
	affiliatedOrganizationConnections: Array<Connection>;
	avatarFile?: Maybe<File>;
	bannerFile?: Maybe<File>;
	businessLines?: Maybe<Array<BusinessLine>>;
	callouts?: Maybe<Array<Callout>>;
	connection?: Maybe<Connection>;
	conversationInsuranceProfileLink?: Maybe<Scalars['String']['output']>;
	deactivated: Scalars['Boolean']['output'];
	displayLocation?: Maybe<Scalars['String']['output']>;
	displayName: Scalars['String']['output'];
	displayPhoneNumber?: Maybe<PhoneNumber>;
	facebookProfileLink?: Maybe<Scalars['String']['output']>;
	following?: Maybe<Scalars['Boolean']['output']>;
	id: Scalars['ID']['output'];
	industry?: Maybe<Industry>;
	linkedinProfileLink?: Maybe<Scalars['String']['output']>;
	numberOfEmployees?: Maybe<EmployeeCount>;
	primaryAddress?: Maybe<Address>;
	tagline?: Maybe<Scalars['String']['output']>;
	websiteUrl?: Maybe<Scalars['String']['output']>;
	xProfileLink?: Maybe<Scalars['String']['output']>;
	yearFounded?: Maybe<Scalars['Float']['output']>;
};

export type OrganizationProfileUpdate = {
	callouts?: InputMaybe<Array<CalloutUpdate>>;
	conversationInsuranceProfileLink?: InputMaybe<Scalars['String']['input']>;
	displayName: Scalars['String']['input'];
	facebookProfileLink?: InputMaybe<Scalars['String']['input']>;
	linkedinProfileLink?: InputMaybe<Scalars['String']['input']>;
	tagline?: InputMaybe<Scalars['String']['input']>;
	xProfileLink?: InputMaybe<Scalars['String']['input']>;
};

export type OrganizationRepresentativePagingResponse = {
	__typename?: 'OrganizationRepresentativePagingResponse';
	items: Array<Representative>;
	totalCount: Scalars['Int']['output'];
};

export type OrganizationRole = {
	__typename?: 'OrganizationRole';
	associateCount: Scalars['Int']['output'];
	category: OrganizationRoleCategory;
	id: Scalars['ID']['output'];
	isAdminRole: Scalars['Boolean']['output'];
	name: Scalars['String']['output'];
	organizationId: Scalars['String']['output'];
	permissionKeys: Array<Scalars['String']['output']>;
};

export type OrganizationRoleCategory = {
	__typename?: 'OrganizationRoleCategory';
	id: Scalars['ID']['output'];
	name: Scalars['String']['output'];
};

export type OrganizationRolePagingResponse = {
	__typename?: 'OrganizationRolePagingResponse';
	items: Array<OrganizationRole>;
	totalCount: Scalars['Int']['output'];
};

export type OrganizationRoleUpdate = {
	categoryId: Scalars['String']['input'];
	name: Scalars['String']['input'];
	permissionKeys: Array<Scalars['String']['input']>;
};

export type PagingResponseOfAssociateOrInvitation = {
	__typename?: 'PagingResponseOfAssociateOrInvitation';
	items: Array<AssociateOrInvitation>;
	totalCount: Scalars['Int']['output'];
};

export type PagingResponseOfConnection = {
	__typename?: 'PagingResponseOfConnection';
	items: Array<Connection>;
	totalCount: Scalars['Float']['output'];
};

export type PagingResponseOfFollow = {
	__typename?: 'PagingResponseOfFollow';
	items: Array<Follow>;
	totalCount: Scalars['Float']['output'];
};

export type PagingResponseOfJournalEntry = {
	__typename?: 'PagingResponseOfJournalEntry';
	items: Array<JournalEntry>;
	totalCount: Scalars['Float']['output'];
};

export type PagingResponseOfLocationAddress = {
	__typename?: 'PagingResponseOfLocationAddress';
	items: Array<LocationAddress>;
	totalCount: Scalars['Float']['output'];
};

export type PagingResponseOfNotificationSummary = {
	__typename?: 'PagingResponseOfNotificationSummary';
	items: Array<NotificationSummary>;
	totalCount: Scalars['Float']['output'];
};

/** Response object for getting a paging list of chat messages. */
export type PagingResponseOfUserChatMessage = {
	__typename?: 'PagingResponseOfUserChatMessage';
	items: Array<UserChatMessage>;
	totalCount: Scalars['Int']['output'];
};

export type ParentEntity = {
	__typename?: 'ParentEntity';
	entityCurrentValue?: Maybe<Scalars['String']['output']>;
	entityId: Scalars['String']['output'];
	entityName?: Maybe<Scalars['String']['output']>;
};

export type Participant = {
	entityId: Scalars['String']['input'];
	entityType: ParticipantEntityType;
};

export enum ParticipantEntityType {
	LegacyClaim = 'LegacyClaim',
	Organization = 'Organization',
	System = 'System',
	Unknown = 'Unknown',
	User = 'User',
}

export enum ParticipantHistoryType {
	All = 'All',
	None = 'None',
	Partial = 'Partial',
}

export type ParticipantLabel = {
	__typename?: 'ParticipantLabel';
	id: Scalars['ID']['output'];
	name: Scalars['String']['output'];
	type: LabelType;
};

export type PeopleSearchResult = {
	__typename?: 'PeopleSearchResult';
	affiliation?: Maybe<Scalars['String']['output']>;
	avatarFile?: Maybe<File>;
	cellPhone?: Maybe<PhoneNumber>;
	companyName?: Maybe<Scalars['String']['output']>;
	emailAddress: Scalars['String']['output'];
	firstName: Scalars['String']['output'];
	handle?: Maybe<Scalars['String']['output']>;
	homePhone?: Maybe<PhoneNumber>;
	lastName: Scalars['String']['output'];
	secondaryEmailAddress?: Maybe<Scalars['String']['output']>;
	siteRole?: Maybe<Scalars['String']['output']>;
	siteUserId?: Maybe<Scalars['String']['output']>;
	siteUserInvitationId?: Maybe<Scalars['String']['output']>;
	userActive?: Maybe<Scalars['Boolean']['output']>;
	userId?: Maybe<Scalars['String']['output']>;
};

export type PermissionCategories = {
	__typename?: 'PermissionCategories';
	categories: Array<PermissionCategory>;
};

export type PermissionCategory = {
	__typename?: 'PermissionCategory';
	categoryType: Scalars['String']['output'];
	description: Scalars['String']['output'];
	displayOrder: Scalars['Int']['output'];
	name: Scalars['String']['output'];
	permissionGroups: Array<PermissionGroup>;
};

export type PermissionGroup = {
	__typename?: 'PermissionGroup';
	description: Scalars['String']['output'];
	displayOrder: Scalars['Int']['output'];
	name: Scalars['String']['output'];
	permissions: Array<OperationPermission>;
};

export type PersonName = {
	__typename?: 'PersonName';
	firstName?: Maybe<Scalars['String']['output']>;
	lastName?: Maybe<Scalars['String']['output']>;
	middleName?: Maybe<Scalars['String']['output']>;
	suffix?: Maybe<Scalars['String']['output']>;
};

export type PersonNameInput = {
	firstName: Scalars['String']['input'];
	lastName: Scalars['String']['input'];
	middleName?: InputMaybe<Scalars['String']['input']>;
	suffix?: InputMaybe<Scalars['String']['input']>;
};

export type PhoneNumber = {
	__typename?: 'PhoneNumber';
	countryCode: Scalars['String']['output'];
	number: Scalars['String']['output'];
};

export type PhoneNumberInput = {
	countryCode: Scalars['String']['input'];
	number: Scalars['String']['input'];
};

export type PolicyCategory = {
	__typename?: 'PolicyCategory';
	code: Scalars['String']['output'];
	id: Scalars['String']['output'];
	name: Scalars['String']['output'];
	policyTypes: Array<PolicyType>;
};

export type PolicyType = {
	__typename?: 'PolicyType';
	code: Scalars['String']['output'];
	id: Scalars['String']['output'];
	lossTypes: Array<LossType>;
	name: Scalars['String']['output'];
};

export type PricingModelValidationResults = {
	__typename?: 'PricingModelValidationResults';
	errors: Array<Scalars['String']['output']>;
};

/** Request object for creating or updating a prompt clipping. */
export type PromptClippingRequest = {
	/** The content of the clipping. */
	content: Scalars['String']['input'];
	/** The title of the clipping. */
	title: Scalars['String']['input'];
};

/** An individual prompt clipping details. */
export type PromptClippingResponse = {
	__typename?: 'PromptClippingResponse';
	/** The content of the clipping. */
	content?: Maybe<Scalars['String']['output']>;
	/** The Id of the prompt clipping. */
	id: Scalars['ID']['output'];
	/** The title of the clipping. */
	title?: Maybe<Scalars['String']['output']>;
};

/** List of a users prompt clippings. */
export type PromptClippingsResponse = {
	__typename?: 'PromptClippingsResponse';
	/** An array of prompt clippings. */
	clippings?: Maybe<Array<PromptClippingResponse>>;
};

export type PropertyValidationRule = {
	__typename?: 'PropertyValidationRule';
	rule: Scalars['String']['output'];
	values: Array<KeyValuePair>;
};

export type PropertyValidationRules = {
	__typename?: 'PropertyValidationRules';
	property: Scalars['ID']['output'];
	rules: Array<PropertyValidationRule>;
	shape?: Maybe<ValidationRules>;
	type: Scalars['String']['output'];
};

export type Query = {
	__typename?: 'Query';
	account: UserAccount;
	adjusterLicensingSummary: AdjusterLicensingSummaries;
	affiliatedOrganizations: Array<Emblem>;
	allCoverages: Coverages;
	allUserOrgPermissions: Array<UserOrgPermissions>;
	appSettings: AppSettings;
	associateInvitations: AssociateInvitationsResponse;
	associatesOrInvitations: PagingResponseOfAssociateOrInvitation;
	billingAdHocBillingItemsGet: AdHocBillingItemsResponse;
	billingBillingHierarchyValidationResultsGet: BillingHierarchyValidationResults;
	billingCustomerDashboardUrlGet: UrlResponse;
	billingCustomerSummariesGet: OrganizationBillingSummaryResponse;
	billingJournalsForOrganizationGet: PagingResponseOfJournalEntry;
	billingJournalsGet: PagingResponseOfJournalEntry;
	billingOrganizationBillingInfoGet: BillingInfoResponse;
	billingOrganizationBillingInvoicesGet: InvoiceResponse;
	billingOrganizationOptionsGet: OrganizationBillingOptions;
	billingOrganizationPortalUrlGet: UrlResponse;
	billingPreviewInvoiceGet: InvoiceDataResponse;
	billingPricingModelValidationResultsGet: PricingModelValidationResults;
	billingProductsGet: GetProductsResponse;
	billingSiteUserPortalUrlGet: UrlResponse;
	billingStripeUrlsGet: StripeUrlsResponse;
	canAdjusterLicensing: CanAdjusterLicensingOutput;
	canLicenseTypes: Array<CanLicenseTypeLookup>;
	/** Gets a chat conversation by id. */
	chatConversationGet: UserChatMessageResponse;
	/** Gets all the saved conversations for the calling user. */
	chatConversationGetAllSaved: SavedConversationsResponse;
	/** Gets a users latest chat conversation. */
	chatConversationGetLatest: LatestChatConversationResponse;
	/** Gets a saved chat conversation. */
	chatConversationGetSaved: UserChatMessageResponse;
	/** Gets the users custom instructions. */
	chatCustomInstructionsGet: CustomInstructions;
	/** Gets the last message of all the conversations for a specific user. */
	chatLastMessagesByUser: RelevantChatMessagesResponse;
	cognitoDevices: CognitoDevicesResponse;
	conversationGet: Conversation;
	conversationLabelSummaries: LabelsResponse;
	conversationParticipantGet: ConversationParticipant;
	conversationSearch: ConversationSummariesResponse;
	conversationSummariesForLabel: ConversationSummariesResponse;
	conversationsWithParticipants: ListResponseOfConversationSummary;
	countries: Array<Country>;
	country: Country;
	countryAddressFieldLookups: Array<AddressFieldLookup>;
	coverageLookup: Coverages;
	emblem: Emblem;
	entity: HistoryLogResponse;
	environment: Environment;
	evolveSettings: EvolveSettings;
	/** Gets a list of user messages for the Evox Review page. */
	evoxReview: PagingResponseOfUserChatMessage;
	folder: FolderInformation;
	folderReferenceList: FolderReferencesList;
	geocode: GeocodeResponse;
	getAssociatesToBeSeededCount: AssociatesToBeSeededCountResponse;
	getCognitoUser: CognitoUserResponse;
	getFileInformation: FileInformation;
	getFileInstanceDownloadUrl: FileDownloadInformation;
	getFileInstances: FileInstanceResponse;
	getOrgBadgeCounts: OrgBadgeCountResponse;
	getOrgConfigurationSettings: OrgDashboardConfigurationResponse;
	getOrganizationAncestors: OrganizationAncestorsResponse;
	getOrganizationImmediateFamily: OrganizationImmediateFamilyResponse;
	getOrganizations: OrganizationAccountPagingResponse;
	getRecommendedLogoUrl: RecommendedLogoUrlResponse;
	getUploadUrl: FileUploadResponse;
	getUserBadgeCounts: UserBadgeCountResponse;
	handleSearch?: Maybe<EntitySearch>;
	jobIndustries: Array<JobIndustry>;
	jobSpecialties: Array<JobSpecialty>;
	jobTypes: Array<JobType>;
	languages: Array<Language>;
	legacyAdjustmentCompanyInfo: AdjustmentCompanyInfo;
	legacyCanCallerLink: CanCallerLinkResult;
	legacyClaimSummaries: LegacyClaimSummariesResult;
	legacyDatabases: Array<LegacyDatabase>;
	legacyInvitationProcess: LegacyInvitationInfoResponse;
	linkedLegacyAdjustmentCompanyInfo: LinkedAdjustmentCompanyInfo;
	loginInformation: UserLogin;
	notificationSettingDefaults: Array<NotificationSettingDefaultGroupResponse>;
	notificationSettingForUser: NotificationSettings;
	notifications: NotificationPagingResponse;
	orgOrDescendentIsLinked: IsLinkedResponse;
	orgQuickLinks: Array<QuickLink>;
	orgSystemSearch: Array<OrgSearchResult>;
	organizationAccount: OrganizationAccount;
	organizationAccountGetConversationInsurance: ConversationInsuranceResponse;
	organizationConnectionsOrRequests: PagingResponseOfConnection;
	organizationFollowers: PagingResponseOfFollow;
	organizationLocationAddresses: PagingResponseOfLocationAddress;
	organizationNotificationDetails: NotificationDetail;
	organizationNotifications: PagingResponseOfNotificationSummary;
	organizationProfile: OrganizationProfile;
	organizationRepresentatives: OrganizationRepresentativePagingResponse;
	organizationTeamMembers: ListResponseOfEmblem;
	participantExactHandleSearch: Array<QuickSearchEntity>;
	participantSearch: Array<QuickSearchEntity>;
	peopleSearch: Array<PeopleSearchResult>;
	permissionCategories: PermissionCategories;
	profile: UserProfile;
	profilePrivacies: Array<UserProfileEffectivePrivacy>;
	profilePrivacy: UserProfileEffectivePrivacy;
	/** Gets a list of the users prompt clippings. */
	promptClippingsGet: PromptClippingsResponse;
	quickLinks: Array<QuickLink>;
	quickSearch: Array<QuickSearchEntity>;
	role: OrganizationRole;
	roleCategories: Array<OrganizationRoleCategory>;
	roles: OrganizationRolePagingResponse;
	rootFolderContents: FolderContents;
	searchFolders: FolderContents;
	sitePermissionCategories: PermissionCategories;
	siteRole: SiteRole;
	siteRoleCategories: Array<SiteRoleCategory>;
	siteRoles: SiteRolePagingResponse;
	siteUser: SiteUser;
	siteUserEmblems: EmblemPagingResponse;
	skills: Array<Skill>;
	systemNotificationDetails: NotificationDetail;
	systemNotifications: PagingResponseOfNotificationSummary;
	usaAdjusterLicensing: UsaAdjusterLicensingOutput;
	usaLicenseClasses: Array<UsaLicenseClassLookup>;
	usaLinesOfAuthority: Array<UsaLicenseClassLookup>;
	usaNiprAdjusterLookup: Array<UsaNiprAdjusterLookup>;
	userConnections: PagingResponseOfConnection;
	userConnectionsOrRequests: PagingResponseOfConnection;
	userDashboardConfigurationSettings: UserDashboardConfigurationResponse;
	userFollowers: PagingResponseOfFollow;
	userFollows: PagingResponseOfFollow;
	userLegacyAdjustmentCompanies: LegacyUserAdjustmentCompanies;
	userLegacyAdjustmentCompaniesWithMetrics: LegacyUserAdjustmentCompaniesWithMetrics;
	userLegacyAdjustmentCompaniesWithMetricsBySystemAndAcid: LegacyUserAdjustmentCompaniesWithMetrics;
	userLocationAddresses: PagingResponseOfLocationAddress;
	userOrgPermissions: UserOrgPermissions;
	userProfileEducationGet: UserEducationResponse;
	userProfileExperienceGet: UserExperienceResponse;
	userProfileSkillEndorsementsGet: UserSkillEndorsementResponse;
	userProfileSkillPlacesUsedGet: UserSkillPlacesUsedResponse;
	userProfileSkillsGet: UserSkillsResponse;
	validationRules: ValidationRules;
	versionNumber: Scalars['String']['output'];
	workTypes: Array<WorkType>;
	zendeskAuth: ZendeskAuthResponse;
};

export type QueryAccountArgs = {
	userId: Scalars['ID']['input'];
};

export type QueryAdjusterLicensingSummaryArgs = {
	userId: Scalars['ID']['input'];
};

export type QueryAffiliatedOrganizationsArgs = {
	userId: Scalars['ID']['input'];
};

export type QueryAllCoveragesArgs = {
	countryId: Scalars['ID']['input'];
};

export type QueryAssociatesOrInvitationsArgs = {
	includeActive: Scalars['Boolean']['input'];
	includeDeclined: Scalars['Boolean']['input'];
	includeInactive: Scalars['Boolean']['input'];
	includeInvited: Scalars['Boolean']['input'];
	offset: Scalars['Float']['input'];
	organizationId: Scalars['ID']['input'];
	pageSize: Scalars['Float']['input'];
	searchFor: Scalars['String']['input'];
	sortDirection: Scalars['String']['input'];
	sortedBy: Scalars['String']['input'];
};

export type QueryBillingAdHocBillingItemsGetArgs = {
	organizationId: Scalars['String']['input'];
};

export type QueryBillingCustomerDashboardUrlGetArgs = {
	organizationId: Scalars['String']['input'];
};

export type QueryBillingJournalsForOrganizationGetArgs = {
	organizationId: Scalars['String']['input'];
	request: JournalSearchRequest;
};

export type QueryBillingJournalsGetArgs = {
	request: JournalSearchRequest;
};

export type QueryBillingOrganizationBillingInfoGetArgs = {
	organizationId: Scalars['String']['input'];
};

export type QueryBillingOrganizationBillingInvoicesGetArgs = {
	numDays: Scalars['Int']['input'];
	organizationId: Scalars['String']['input'];
};

export type QueryBillingOrganizationOptionsGetArgs = {
	organizationId: Scalars['String']['input'];
};

export type QueryBillingOrganizationPortalUrlGetArgs = {
	organizationId: Scalars['String']['input'];
	returnUrl: Scalars['String']['input'];
};

export type QueryBillingPreviewInvoiceGetArgs = {
	generateDraftInvoice: Scalars['Boolean']['input'];
	invoiceDate: Scalars['Date']['input'];
	organizationId: Scalars['String']['input'];
	usage?: InputMaybe<BillingUsage>;
};

export type QueryBillingSiteUserPortalUrlGetArgs = {
	organizationId: Scalars['String']['input'];
	returnUrl: Scalars['String']['input'];
};

export type QueryCanAdjusterLicensingArgs = {
	userId: Scalars['ID']['input'];
};

export type QueryCanLicenseTypesArgs = {
	province?: InputMaybe<Scalars['String']['input']>;
};

export type QueryChatConversationGetArgs = {
	conversationId: Scalars['ID']['input'];
};

export type QueryChatConversationGetAllSavedArgs = {
	userId: Scalars['ID']['input'];
};

export type QueryChatConversationGetLatestArgs = {
	userId: Scalars['ID']['input'];
};

export type QueryChatConversationGetSavedArgs = {
	conversationId: Scalars['ID']['input'];
	userId: Scalars['ID']['input'];
};

export type QueryChatCustomInstructionsGetArgs = {
	userId: Scalars['ID']['input'];
};

export type QueryChatLastMessagesByUserArgs = {
	conversationTypeFilter?: InputMaybe<Array<ConversationTypeFilter>>;
	userId: Scalars['ID']['input'];
};

export type QueryCognitoDevicesArgs = {
	userId: Scalars['ID']['input'];
};

export type QueryConversationGetArgs = {
	conversationId: Scalars['String']['input'];
	entityId: Scalars['String']['input'];
	entityType: ConversationApiEntityType;
	metadata?: InputMaybe<Array<KeyValuePairInput>>;
};

export type QueryConversationLabelSummariesArgs = {
	entityId: Scalars['String']['input'];
	entityType: ConversationApiEntityType;
	metadata?: InputMaybe<Array<KeyValuePairInput>>;
};

export type QueryConversationParticipantGetArgs = {
	conversationId: Scalars['String']['input'];
	userId: Scalars['String']['input'];
};

export type QueryConversationSearchArgs = {
	entityId: Scalars['String']['input'];
	entityType: ConversationApiEntityType;
	labelId: Scalars['String']['input'];
	metadata?: InputMaybe<Array<KeyValuePairInput>>;
	offset: Scalars['Int']['input'];
	pageSize: Scalars['Int']['input'];
	searchText: Scalars['String']['input'];
};

export type QueryConversationSummariesForLabelArgs = {
	entityId: Scalars['String']['input'];
	entityType: ConversationApiEntityType;
	labelId: Scalars['String']['input'];
	metadata?: InputMaybe<Array<KeyValuePairInput>>;
	offset: Scalars['Int']['input'];
	pageSize: Scalars['Int']['input'];
};

export type QueryConversationsWithParticipantsArgs = {
	entityId: Scalars['String']['input'];
	entityIds: Array<Scalars['String']['input']>;
	entityType: ConversationApiEntityType;
	metadata?: InputMaybe<Array<KeyValuePairInput>>;
};

export type QueryCountryArgs = {
	id: Scalars['String']['input'];
};

export type QueryCountryAddressFieldLookupsArgs = {
	id: Scalars['String']['input'];
};

export type QueryCoverageLookupArgs = {
	countryId: Scalars['String']['input'];
	lossTypeId: Scalars['String']['input'];
	policyCategoryId: Scalars['String']['input'];
	policyTypeId: Scalars['String']['input'];
};

export type QueryEmblemArgs = {
	entityId: Scalars['ID']['input'];
	entityType: EmblemEntityType;
};

export type QueryEntityArgs = {
	entityId: Scalars['String']['input'];
	historyLogId?: InputMaybe<Scalars['String']['input']>;
};

export type QueryEvoxReviewArgs = {
	chatMessageRating?: InputMaybe<ChatMessageRating>;
	conversationTypeFilter?: InputMaybe<Array<ConversationTypeFilter>>;
	offset?: InputMaybe<Scalars['Float']['input']>;
	pageSize?: InputMaybe<Scalars['Float']['input']>;
	sortDirection?: InputMaybe<SortDirection>;
};

export type QueryFolderArgs = {
	entityId: Scalars['String']['input'];
	entityType: FoldersApiEntityType;
	folderId: Scalars['String']['input'];
};

export type QueryFolderReferenceListArgs = {
	entityId: Scalars['String']['input'];
	entityType: FoldersApiEntityType;
};

export type QueryGeocodeArgs = {
	address: AddressInput;
};

export type QueryGetAssociatesToBeSeededCountArgs = {
	orgId: Scalars['ID']['input'];
};

export type QueryGetCognitoUserArgs = {
	userId: Scalars['ID']['input'];
};

export type QueryGetFileInformationArgs = {
	fileId: Scalars['String']['input'];
};

export type QueryGetFileInstanceDownloadUrlArgs = {
	fileInstanceId: Scalars['String']['input'];
	inline?: InputMaybe<Scalars['Boolean']['input']>;
	sasUrlOnly?: InputMaybe<Scalars['Boolean']['input']>;
};

export type QueryGetFileInstancesArgs = {
	fileId: Scalars['String']['input'];
};

export type QueryGetOrgBadgeCountsArgs = {
	hasMessagesRead: Scalars['Boolean']['input'];
	hasSocialRead: Scalars['Boolean']['input'];
	organizationId: Scalars['ID']['input'];
};

export type QueryGetOrgConfigurationSettingsArgs = {
	orgId: Scalars['ID']['input'];
};

export type QueryGetOrganizationAncestorsArgs = {
	onlyAssociateCreate?: InputMaybe<Scalars['Boolean']['input']>;
	orgId: Scalars['ID']['input'];
};

export type QueryGetOrganizationImmediateFamilyArgs = {
	orgId: Scalars['ID']['input'];
};

export type QueryGetOrganizationsArgs = {
	offset: Scalars['Float']['input'];
	pageSize: Scalars['Float']['input'];
	searchFor: Scalars['String']['input'];
	sortDirection: SortDirection;
	sortedBy: Scalars['String']['input'];
};

export type QueryGetRecommendedLogoUrlArgs = {
	websiteUrl: Scalars['String']['input'];
};

export type QueryGetUploadUrlArgs = {
	request: FileUploadRequest;
};

export type QueryGetUserBadgeCountsArgs = {
	userId: Scalars['ID']['input'];
};

export type QueryHandleSearchArgs = {
	handle: Scalars['String']['input'];
};

export type QueryJobIndustriesArgs = {
	countryId: Scalars['ID']['input'];
};

export type QueryJobSpecialtiesArgs = {
	countryId: Scalars['ID']['input'];
	industryId: Scalars['ID']['input'];
};

export type QueryJobTypesArgs = {
	countryId: Scalars['ID']['input'];
	industryId: Scalars['ID']['input'];
	specialtyId: Scalars['ID']['input'];
};

export type QueryLegacyAdjustmentCompanyInfoArgs = {
	acid: Scalars['Int']['input'];
	systemId: Scalars['Int']['input'];
};

export type QueryLegacyCanCallerLinkArgs = {
	acid: Scalars['Int']['input'];
	systemId: Scalars['Int']['input'];
};

export type QueryLegacyClaimSummariesArgs = {
	count: Scalars['Int']['input'];
	legacySystemId: Scalars['Int']['input'];
	legacyUserId: Scalars['Int']['input'];
	roleType: ClaimSummaryRoleType;
	subset: ClaimSummarySubset;
};

export type QueryLegacyInvitationProcessArgs = {
	invitationId: Scalars['ID']['input'];
};

export type QueryLinkedLegacyAdjustmentCompanyInfoArgs = {
	orgId: Scalars['ID']['input'];
};

export type QueryNotificationSettingForUserArgs = {
	userId: Scalars['ID']['input'];
};

export type QueryNotificationsArgs = {
	limit: Scalars['Int']['input'];
	markAllAsSeen: Scalars['Boolean']['input'];
	offset: Scalars['Int']['input'];
	types?: InputMaybe<Array<NotificationType>>;
};

export type QueryOrgOrDescendentIsLinkedArgs = {
	orgId: Scalars['ID']['input'];
};

export type QueryOrgQuickLinksArgs = {
	orgId: Scalars['ID']['input'];
};

export type QueryOrgSystemSearchArgs = {
	activationStatus?: InputMaybe<ActivationStatus>;
	location?: InputMaybe<Scalars['String']['input']>;
	searchText: Scalars['String']['input'];
};

export type QueryOrganizationAccountArgs = {
	organizationId: Scalars['ID']['input'];
};

export type QueryOrganizationAccountGetConversationInsuranceArgs = {
	organizationId: Scalars['ID']['input'];
};

export type QueryOrganizationConnectionsOrRequestsArgs = {
	markInboundAsSeen?: InputMaybe<Scalars['Boolean']['input']>;
	offset: Scalars['Float']['input'];
	organizationId: Scalars['ID']['input'];
	pageSize: Scalars['Float']['input'];
	pageType: ConnectionPageType;
	searchFor: Scalars['String']['input'];
	sortDirection: SortDirection;
	sortedBy: ConnectionSortBy;
};

export type QueryOrganizationFollowersArgs = {
	offset: Scalars['Float']['input'];
	organizationId: Scalars['ID']['input'];
	pageSize: Scalars['Float']['input'];
	searchFor: Scalars['String']['input'];
	sortDirection: Scalars['String']['input'];
	sortedBy: Scalars['String']['input'];
};

export type QueryOrganizationLocationAddressesArgs = {
	offset: Scalars['Float']['input'];
	organizationId: Scalars['ID']['input'];
	pageSize: Scalars['Float']['input'];
	searchFor: Scalars['String']['input'];
	sortDirection: SortDirection;
};

export type QueryOrganizationNotificationDetailsArgs = {
	notificationId: Scalars['ID']['input'];
	organizationId: Scalars['ID']['input'];
};

export type QueryOrganizationNotificationsArgs = {
	offset: Scalars['Int']['input'];
	organizationId: Scalars['ID']['input'];
	pageSize: Scalars['Int']['input'];
	searchText: Scalars['String']['input'];
};

export type QueryOrganizationProfileArgs = {
	organizationId: Scalars['ID']['input'];
};

export type QueryOrganizationRepresentativesArgs = {
	offset: Scalars['Float']['input'];
	organizationId: Scalars['ID']['input'];
	pageSize: Scalars['Float']['input'];
	searchFor: Scalars['String']['input'];
	sortDirection: SortDirection;
};

export type QueryOrganizationTeamMembersArgs = {
	organizationId: Scalars['ID']['input'];
};

export type QueryParticipantExactHandleSearchArgs = {
	entityId: Scalars['String']['input'];
	handle?: InputMaybe<Scalars['String']['input']>;
};

export type QueryParticipantSearchArgs = {
	entityId: Scalars['String']['input'];
	entityType: EntitySearchType;
	limit: Scalars['Float']['input'];
	query?: InputMaybe<Scalars['String']['input']>;
};

export type QueryPeopleSearchArgs = {
	activationStatus?: InputMaybe<ActivationStatus>;
	affiliation?: InputMaybe<Scalars['String']['input']>;
	companyName?: InputMaybe<Scalars['String']['input']>;
	searchText: Scalars['String']['input'];
	userType: UserType;
};

export type QueryProfileArgs = {
	userId: Scalars['ID']['input'];
};

export type QueryProfilePrivaciesArgs = {
	userId: Scalars['ID']['input'];
};

export type QueryProfilePrivacyArgs = {
	type: Scalars['String']['input'];
	userId: Scalars['ID']['input'];
};

export type QueryPromptClippingsGetArgs = {
	userId: Scalars['ID']['input'];
};

export type QueryQuickLinksArgs = {
	userId: Scalars['ID']['input'];
};

export type QueryQuickSearchArgs = {
	entitySearchMode?: InputMaybe<EntitySearchMode>;
	limit: Scalars['Float']['input'];
	query: Scalars['String']['input'];
};

export type QueryRoleArgs = {
	organizationId: Scalars['ID']['input'];
	roleId: Scalars['ID']['input'];
};

export type QueryRolesArgs = {
	offset?: InputMaybe<Scalars['Float']['input']>;
	organizationId: Scalars['ID']['input'];
	pageSize?: InputMaybe<Scalars['Float']['input']>;
	sortDirection?: InputMaybe<Scalars['String']['input']>;
	sortedBy?: InputMaybe<Scalars['String']['input']>;
};

export type QueryRootFolderContentsArgs = {
	entityId: Scalars['String']['input'];
	entityType: FoldersApiEntityType;
};

export type QuerySearchFoldersArgs = {
	entityId: Scalars['String']['input'];
	entityType: FoldersApiEntityType;
	request: SearchFoldersRequest;
};

export type QuerySiteRoleArgs = {
	id: Scalars['String']['input'];
};

export type QuerySiteRolesArgs = {
	offset?: InputMaybe<Scalars['Float']['input']>;
	pageSize?: InputMaybe<Scalars['Float']['input']>;
	searchFor?: InputMaybe<Scalars['String']['input']>;
	sortDirection?: InputMaybe<SortDirection>;
	sortedBy?: InputMaybe<Scalars['String']['input']>;
};

export type QuerySiteUserArgs = {
	id: Scalars['ID']['input'];
};

export type QuerySiteUserEmblemsArgs = {
	offset: Scalars['Float']['input'];
	pageSize: Scalars['Float']['input'];
	searchFor: Scalars['String']['input'];
	sortDirection: SortDirection;
	sortedBy: Scalars['String']['input'];
};

export type QuerySkillsArgs = {
	skillIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type QuerySystemNotificationDetailsArgs = {
	notificationId: Scalars['ID']['input'];
};

export type QuerySystemNotificationsArgs = {
	offset: Scalars['Int']['input'];
	pageSize: Scalars['Int']['input'];
	searchText: Scalars['String']['input'];
};

export type QueryUsaAdjusterLicensingArgs = {
	userId: Scalars['ID']['input'];
};

export type QueryUsaLicenseClassesArgs = {
	state: Scalars['String']['input'];
};

export type QueryUsaLinesOfAuthorityArgs = {
	state: Scalars['String']['input'];
};

export type QueryUsaNiprAdjusterLookupArgs = {
	birthDate: Scalars['Date']['input'];
	firstName?: InputMaybe<Scalars['String']['input']>;
	lastName?: InputMaybe<Scalars['String']['input']>;
	middleName?: InputMaybe<Scalars['String']['input']>;
	npnNumber?: InputMaybe<Scalars['Int']['input']>;
	ssNumber?: InputMaybe<Scalars['String']['input']>;
};

export type QueryUserConnectionsArgs = {
	offset: Scalars['Float']['input'];
	pageSize: Scalars['Float']['input'];
	searchFor: Scalars['String']['input'];
	sortDirection: SortDirection;
	sortedBy: ConnectionSortBy;
	userId: Scalars['ID']['input'];
};

export type QueryUserConnectionsOrRequestsArgs = {
	markInboundAsSeen?: InputMaybe<Scalars['Boolean']['input']>;
	offset: Scalars['Float']['input'];
	pageSize: Scalars['Float']['input'];
	pageType: ConnectionPageType;
	searchFor: Scalars['String']['input'];
	sortDirection: SortDirection;
	sortedBy: ConnectionSortBy;
	userId: Scalars['ID']['input'];
};

export type QueryUserDashboardConfigurationSettingsArgs = {
	userId: Scalars['ID']['input'];
};

export type QueryUserFollowersArgs = {
	offset: Scalars['Float']['input'];
	pageSize: Scalars['Float']['input'];
	searchFor: Scalars['String']['input'];
	sortDirection: Scalars['String']['input'];
	sortedBy: Scalars['String']['input'];
	userId: Scalars['ID']['input'];
};

export type QueryUserFollowsArgs = {
	offset: Scalars['Float']['input'];
	pageSize: Scalars['Float']['input'];
	searchFor: Scalars['String']['input'];
	sortDirection: Scalars['String']['input'];
	sortedBy: Scalars['String']['input'];
	userId: Scalars['ID']['input'];
};

export type QueryUserLegacyAdjustmentCompaniesWithMetricsBySystemAndAcidArgs = {
	acid: Scalars['Int']['input'];
	systemId: Scalars['Int']['input'];
};

export type QueryUserLocationAddressesArgs = {
	offset: Scalars['Float']['input'];
	pageSize: Scalars['Float']['input'];
	searchFor: Scalars['String']['input'];
	sortDirection: SortDirection;
	userId: Scalars['ID']['input'];
};

export type QueryUserOrgPermissionsArgs = {
	orgId: Scalars['ID']['input'];
};

export type QueryUserProfileEducationGetArgs = {
	userId: Scalars['ID']['input'];
};

export type QueryUserProfileExperienceGetArgs = {
	userId: Scalars['ID']['input'];
};

export type QueryUserProfileSkillEndorsementsGetArgs = {
	userId: Scalars['ID']['input'];
	userSkillId: Scalars['ID']['input'];
};

export type QueryUserProfileSkillPlacesUsedGetArgs = {
	userId: Scalars['ID']['input'];
	userSkillId: Scalars['ID']['input'];
};

export type QueryUserProfileSkillsGetArgs = {
	userId: Scalars['ID']['input'];
};

export type QueryValidationRulesArgs = {
	typeName: Scalars['String']['input'];
};

export type QuickLink = {
	__typename?: 'QuickLink';
	iconFile?: Maybe<FileInformation>;
	iconFileId?: Maybe<Scalars['String']['output']>;
	id: Scalars['ID']['output'];
	title: Scalars['String']['output'];
	url: Scalars['String']['output'];
};

export type QuickLinkCreate = {
	iconUploadToken?: InputMaybe<Scalars['String']['input']>;
	title: Scalars['String']['input'];
	url: Scalars['String']['input'];
};

export type QuickLinkPatch = {
	clearIconFlag: Scalars['Boolean']['input'];
	iconUploadToken?: InputMaybe<Scalars['String']['input']>;
	title: Scalars['String']['input'];
	url: Scalars['String']['input'];
};

export type QuickSearchEntity = {
	__typename?: 'QuickSearchEntity';
	avatarFileId?: Maybe<Scalars['String']['output']>;
	displayName: Scalars['String']['output'];
	displayPicture?: Maybe<File>;
	entityType: EntitySearchType;
	handle?: Maybe<Scalars['String']['output']>;
	id: Scalars['ID']['output'];
	location?: Maybe<Scalars['String']['output']>;
	relevance: Scalars['Int']['output'];
};

export type RecommendedLogoUrlResponse = {
	__typename?: 'RecommendedLogoUrlResponse';
	logoUrl?: Maybe<Scalars['String']['output']>;
};

export enum RelatedEntityType {
	Billing = 'Billing',
	LegacyClaim = 'LegacyClaim',
	Message = 'Message',
	None = 'None',
	Organization = 'Organization',
	SiteUserInvitation = 'SiteUserInvitation',
	User = 'User',
}

/** Response object for getting a list of chat messages. */
export type RelevantChatMessagesResponse = {
	__typename?: 'RelevantChatMessagesResponse';
	/** An array of chat message responses to a request. */
	relevantChatMessages: Array<UserChatMessage>;
};

export type Representative = {
	__typename?: 'Representative';
	cellPhoneNumber: PhoneNumber;
	emailAddress: Scalars['String']['output'];
	id: Scalars['ID']['output'];
	name: PersonName;
	organizationId: Scalars['String']['output'];
	representativeType: Array<RepresentativeType>;
	title: Scalars['String']['output'];
	workPhoneNumber?: Maybe<PhoneNumber>;
};

export enum RepresentativeType {
	Billing = 'Billing',
	Operational = 'Operational',
	Primary = 'Primary',
	Technical = 'Technical',
}

export type RepresentativeUpdate = {
	cellPhoneNumber: PhoneNumberInput;
	emailAddress: Scalars['String']['input'];
	name: PersonNameInput;
	representativeType: Array<RepresentativeType>;
	title: Scalars['String']['input'];
	workPhoneNumber?: InputMaybe<PhoneNumberInput>;
};

/** Request object for saving or updating a chat conversation. */
export type SaveConversationRequest = {
	/** The name of the saved conversation. */
	conversationName: Scalars['String']['input'];
};

/** Represents a saved chat conversation. */
export type SavedConversation = {
	__typename?: 'SavedConversation';
	/** The conversation ID. */
	conversationId: Scalars['ID']['output'];
	/** The saved name of the conversation. */
	conversationName: Scalars['String']['output'];
};

/** Response object for getting a users save chat conversations. */
export type SavedConversationsResponse = {
	__typename?: 'SavedConversationsResponse';
	/** The saved conversations. */
	savedConversations: Array<SavedConversation>;
};

export type SearchFoldersRequest = {
	caseSensitive: Scalars['Boolean']['input'];
	currentInstanceOnly: Scalars['Boolean']['input'];
	searchType: FolderSearchType;
	searchValue: Scalars['String']['input'];
};

export type SiteRole = {
	__typename?: 'SiteRole';
	id: Scalars['ID']['output'];
	isAdminRole?: Maybe<Scalars['Boolean']['output']>;
	lastModifiedUtc?: Maybe<Scalars['Date']['output']>;
	name: Scalars['String']['output'];
	permissionKeys?: Maybe<Array<Scalars['String']['output']>>;
	siteRoleCategory?: Maybe<SiteRoleCategory>;
	userCount?: Maybe<Scalars['Int']['output']>;
};

export type SiteRoleCategory = {
	__typename?: 'SiteRoleCategory';
	id: Scalars['ID']['output'];
	name: Scalars['String']['output'];
};

export type SiteRolePagingResponse = {
	__typename?: 'SiteRolePagingResponse';
	items: Array<SiteRole>;
	totalCount: Scalars['Int']['output'];
};

export type SiteRoleUpdate = {
	name: Scalars['String']['input'];
	permissionKeys: Array<Scalars['String']['input']>;
	siteRoleCategoryId: Scalars['String']['input'];
};

export type SiteUser = {
	__typename?: 'SiteUser';
	affiliation?: Maybe<Scalars['String']['output']>;
	id: Scalars['ID']['output'];
	profileLastUpdatedUtc?: Maybe<Scalars['Date']['output']>;
	roles?: Maybe<Array<SiteRole>>;
};

export type SiteUserInvitation = {
	__typename?: 'SiteUserInvitation';
	affiliation?: Maybe<Scalars['String']['output']>;
	emailAddress?: Maybe<Scalars['String']['output']>;
	firstName?: Maybe<Scalars['String']['output']>;
	invitationId: Scalars['ID']['output'];
	invitedBySiteUserId?: Maybe<Scalars['String']['output']>;
	invitedDateTimeUtc?: Maybe<Scalars['Date']['output']>;
	lastName?: Maybe<Scalars['String']['output']>;
	role?: Maybe<SiteRole>;
	roleId?: Maybe<Scalars['String']['output']>;
};

export type SiteUserInvitationRequest = {
	affiliation: Scalars['String']['input'];
	firstName: Scalars['String']['input'];
	invitedEmailAddress: Scalars['String']['input'];
	lastName: Scalars['String']['input'];
	roleId: Scalars['String']['input'];
};

export type SiteUserUpdate = {
	affiliation: Scalars['String']['input'];
	siteRoleIds: Array<Scalars['String']['input']>;
};

export type Skill = {
	__typename?: 'Skill';
	id: Scalars['String']['output'];
	name: Scalars['String']['output'];
};

export enum SortDirection {
	Ascending = 'Ascending',
	Descending = 'Descending',
}

export type StoreCognitoDeviceRequest = {
	deviceKey: Scalars['String']['input'];
};

export type StripePriceInfo = {
	__typename?: 'StripePriceInfo';
	billingScheme?: Maybe<Scalars['String']['output']>;
	description?: Maybe<Scalars['String']['output']>;
	effectiveDate: Scalars['Date']['output'];
	interval?: Maybe<Scalars['String']['output']>;
	price: Scalars['Float']['output'];
	priceId: Scalars['String']['output'];
	productId: Scalars['String']['output'];
	type?: Maybe<Scalars['String']['output']>;
};

export type StripeProductInfo = {
	__typename?: 'StripeProductInfo';
	description?: Maybe<Scalars['String']['output']>;
	name: Scalars['String']['output'];
	prices: Array<StripePriceInfo>;
	productId: Scalars['String']['output'];
};

export type StripeUrlsResponse = {
	__typename?: 'StripeUrlsResponse';
	customerDashboardUrl: Scalars['String']['output'];
	invoiceDashboardUrl: Scalars['String']['output'];
	productDashboardUrl: Scalars['String']['output'];
};

export enum SystemFileType {
	EvoxAttachment = 'EvoxAttachment',
	MessageAttachment = 'MessageAttachment',
	OrganizationAvatar = 'OrganizationAvatar',
	OrganizationBanner = 'OrganizationBanner',
	OrganizationCommon = 'OrganizationCommon',
	OrganizationQuickLinkIcon = 'OrganizationQuickLinkIcon',
	UserAvatar = 'UserAvatar',
	UserBanner = 'UserBanner',
	UserQuickLinkIcon = 'UserQuickLinkIcon',
}

export enum SystemNotificationAudience {
	None = 'None',
	OrgAdmins = 'OrgAdmins',
	SocialUsers = 'SocialUsers',
}

export type SystemNotificationRequest = {
	audience: Array<SystemNotificationAudience>;
	emailHtmlBody: Scalars['String']['input'];
	emailSubject: Scalars['String']['input'];
	inAppText: Scalars['String']['input'];
	inAppUrl?: InputMaybe<Scalars['String']['input']>;
	smsSendAsBulk: Scalars['Boolean']['input'];
	smsText: Scalars['String']['input'];
};

export type TeamMemberUpdate = {
	displayPosition: Scalars['Int']['input'];
	userId: Scalars['ID']['input'];
};

export type TeamMembersUpdate = {
	teamMemberUpdates: Array<TeamMemberUpdate>;
};

export type UpdateConversationRequest = {
	subject: Scalars['String']['input'];
};

export type UpsertFolderRequest = {
	name: Scalars['String']['input'];
	parentFolderId?: InputMaybe<Scalars['String']['input']>;
};

export type UrlResponse = {
	__typename?: 'UrlResponse';
	url: Scalars['String']['output'];
};

export type UsaAdjusterLicensingInput = {
	birthDate: Scalars['Date']['input'];
	firstName: Scalars['String']['input'];
	lastName: Scalars['String']['input'];
	middleName?: InputMaybe<Scalars['String']['input']>;
	npn: Scalars['Int']['input'];
	statesLicensing: Array<UsaStateAdjusterLicensingInput>;
	suffix?: InputMaybe<Scalars['String']['input']>;
};

export type UsaAdjusterLicensingOutput = {
	__typename?: 'UsaAdjusterLicensingOutput';
	birthDate?: Maybe<Scalars['Date']['output']>;
	firstName?: Maybe<Scalars['String']['output']>;
	lastName?: Maybe<Scalars['String']['output']>;
	middleName?: Maybe<Scalars['String']['output']>;
	npn: Scalars['Int']['output'];
	statesLicensing: Array<UsaStateAdjusterLicensingOutput>;
	suffix?: Maybe<Scalars['String']['output']>;
};

export type UsaLicenseClassLookup = {
	__typename?: 'UsaLicenseClassLookup';
	code: Scalars['Int']['output'];
	id: Scalars['String']['output'];
	name: Scalars['String']['output'];
	stateId: Scalars['String']['output'];
};

export type UsaLineOfAuthorityLookup = {
	__typename?: 'UsaLineOfAuthorityLookup';
	code: Scalars['Int']['output'];
	id: Scalars['String']['output'];
	name: Scalars['String']['output'];
	stateId: Scalars['String']['output'];
};

export type UsaNiprAdjusterLookup = {
	__typename?: 'UsaNiprAdjusterLookup';
	birthDate?: Maybe<Scalars['Date']['output']>;
	name: Scalars['String']['output'];
	npn: Scalars['Int']['output'];
	stateOfResidence?: Maybe<Scalars['String']['output']>;
};

export type UsaStateAdjusterAppointmentInput = {
	companyName: Scalars['String']['input'];
	lineOfAuthorityId?: InputMaybe<Scalars['String']['input']>;
	renewalDate?: InputMaybe<Scalars['Date']['input']>;
	status: Scalars['String']['input'];
};

export type UsaStateAdjusterAppointmentOutput = {
	__typename?: 'UsaStateAdjusterAppointmentOutput';
	companyName: Scalars['String']['output'];
	lineOfAuthorityId?: Maybe<Scalars['String']['output']>;
	renewalDate?: Maybe<Scalars['Date']['output']>;
	status: Scalars['String']['output'];
};

export type UsaStateAdjusterLicenseInput = {
	active: Scalars['Boolean']['input'];
	expirationDate?: InputMaybe<Scalars['Date']['input']>;
	licenseClassId: Scalars['String']['input'];
	number: Scalars['String']['input'];
	originalIssueDate?: InputMaybe<Scalars['Date']['input']>;
};

export type UsaStateAdjusterLicenseOutput = {
	__typename?: 'UsaStateAdjusterLicenseOutput';
	active: Scalars['Boolean']['output'];
	expirationDate?: Maybe<Scalars['Date']['output']>;
	licenseClassId: Scalars['String']['output'];
	number: Scalars['String']['output'];
	originalIssueDate?: Maybe<Scalars['Date']['output']>;
};

export type UsaStateAdjusterLicensingInput = {
	fullNameAlias?: InputMaybe<Scalars['String']['input']>;
	stateAddressFieldLookupId: Scalars['String']['input'];
	stateAppointments: Array<UsaStateAdjusterAppointmentInput>;
	stateLicenses: Array<UsaStateAdjusterLicenseInput>;
	stateRegulatoryActions: Array<UsaStateAdjusterRegulatoryActionInput>;
};

export type UsaStateAdjusterLicensingOutput = {
	__typename?: 'UsaStateAdjusterLicensingOutput';
	fullNameAlias?: Maybe<Scalars['String']['output']>;
	stateAddressFieldLookupId: Scalars['String']['output'];
	stateAppointments: Array<UsaStateAdjusterAppointmentOutput>;
	stateLicenses: Array<UsaStateAdjusterLicenseOutput>;
	stateRegulatoryActions: Array<UsaStateAdjusterRegulatoryActionOutput>;
};

export type UsaStateAdjusterRegulatoryActionInput = {
	actionDate: Scalars['Date']['input'];
	disposition: Scalars['String']['input'];
};

export type UsaStateAdjusterRegulatoryActionOutput = {
	__typename?: 'UsaStateAdjusterRegulatoryActionOutput';
	actionDate: Scalars['Date']['output'];
	disposition: Scalars['String']['output'];
};

export type UserAccount = {
	__typename?: 'UserAccount';
	avatarFile?: Maybe<File>;
	birthDate?: Maybe<Scalars['Date']['output']>;
	cellPhone?: Maybe<PhoneNumber>;
	deactivated?: Maybe<Scalars['Boolean']['output']>;
	emailAddress: Scalars['String']['output'];
	emergencyContact?: Maybe<AccountEmergencyContact>;
	handle: Scalars['String']['output'];
	homePhone?: Maybe<PhoneNumber>;
	id: Scalars['ID']['output'];
	languageIds?: Maybe<Array<Scalars['String']['output']>>;
	lastUpdatedUtc?: Maybe<Scalars['Date']['output']>;
	name?: Maybe<PersonName>;
	private: Scalars['Boolean']['output'];
	quickLinks?: Maybe<Array<QuickLink>>;
	secondaryEmailAddress?: Maybe<Scalars['String']['output']>;
	siteUserId?: Maybe<Scalars['String']['output']>;
};

export type UserAccountUpdate = {
	avatarUploadToken?: InputMaybe<Scalars['String']['input']>;
	birthDate?: InputMaybe<Scalars['Date']['input']>;
	cellPhone: PhoneNumberInput;
	handle: Scalars['String']['input'];
	homePhone?: InputMaybe<PhoneNumberInput>;
	languageIds: Array<Scalars['String']['input']>;
	name: PersonNameInput;
	secondaryEmailAddress?: InputMaybe<Scalars['String']['input']>;
};

export type UserBadgeCountResponse = {
	__typename?: 'UserBadgeCountResponse';
	associateInvitationsBadgeCount: Scalars['Float']['output'];
	conversationsBadgeCount: Scalars['Float']['output'];
	inboundRequestsBadgeCount: Scalars['Float']['output'];
	notificationsBadgeCount: Scalars['Float']['output'];
};

/** Represents a file associated with a message. */
export type UserChatFile = {
	__typename?: 'UserChatFile';
	/** The ID of the file. */
	chatFileId: Scalars['ID']['output'];
	/** The display name of the file. */
	name: Scalars['String']['output'];
};

/** Represents a footnote associated with a message. */
export type UserChatFootnote = {
	__typename?: 'UserChatFootnote';
	/** The ID of the footnote. */
	chatFootnoteId: Scalars['ID']['output'];
	/** The file display name for the footnote. */
	fileName?: Maybe<Scalars['String']['output']>;
	/** The text snippet for the footnote. */
	snippet?: Maybe<Scalars['String']['output']>;
	/** The url for the footnote. */
	url?: Maybe<Scalars['String']['output']>;
	/** The display name for the url. */
	urlDisplayName?: Maybe<Scalars['String']['output']>;
};

/** Represents a single message in a conversation. */
export type UserChatMessage = {
	__typename?: 'UserChatMessage';
	/** The id of the conversation this message belongs to. */
	chatConversationId: Scalars['ID']['output'];
	/** The ID of the message. */
	chatMessageId: Scalars['ID']['output'];
	/** The message content. */
	content?: Maybe<Scalars['String']['output']>;
	/** The datetime of the message. */
	dateTimeUtc: Scalars['Date']['output'];
	/** An array of files associated with this message. */
	files?: Maybe<Array<UserChatFile>>;
	/** An array of footnotes associated with this message. */
	footnotes?: Maybe<Array<UserChatFootnote>>;
	/** The function call arguments. */
	functionCallArguments?: Maybe<Scalars['String']['output']>;
	/** The function call name. */
	functionCallName?: Maybe<Scalars['String']['output']>;
	/** The name of the function that generated the content if role = FunctionResultsForUser. */
	functionName?: Maybe<Scalars['String']['output']>;
	/** The rating of this message. */
	rating?: Maybe<ChatMessageRating>;
	/** The message creators role. */
	role: ChatMessageRole;
	/** The sequence of this message, used to properly sort messages in a conversation. */
	sequence: Scalars['Float']['output'];
};

/** Chat message file request. */
export type UserChatMessageFileRequest = {
	/** The ID of the file. */
	fileId: Scalars['ID']['input'];
	/** The upload token of the file. */
	fileUploadToken: Scalars['String']['input'];
};

/** Chat message request. */
export type UserChatMessageRequest = {
	/** An array of file attachments to associate to the message. */
	attachments?: InputMaybe<Array<UserChatMessageFileRequest>>;
	/** The caller local timezone offset in minutes. */
	callerTimezoneOffsetMinutes?: InputMaybe<Scalars['Float']['input']>;
	/** The user's message, i.e. 'Find claims for insured Bennett.' */
	content: Scalars['String']['input'];
	/** The conversation ID, when continuing an existing conversation. Pass null to start a new conversation. */
	conversationId: Scalars['ID']['input'];
};

/** Chat message response. */
export type UserChatMessageResponse = {
	__typename?: 'UserChatMessageResponse';
	/** The ID of the chat conversation. */
	chatConversationId: Scalars['ID']['output'];
	/** The name for the conversation, if saved. */
	chatConversationName?: Maybe<Scalars['String']['output']>;
	/** The source of the conversation. */
	chatConversationSource: ChatConversationSource;
	/** The type of the conversation. */
	chatConversationType: ChatConversationType;
	/** An array of chat message responses to a request. */
	chatMessages?: Maybe<Array<UserChatMessage>>;
	/** The number of cumulative tokens for this conversation */
	cumulativeTokens?: Maybe<Scalars['Float']['output']>;
	/** A serialized JSON string of metadata about the conversation. */
	metadata?: Maybe<Scalars['String']['output']>;
	/** The OpenAI thread Id for this conversation */
	openAiThreadId?: Maybe<Scalars['String']['output']>;
	/** The id of the user this conversations belongs to. */
	userId: Scalars['ID']['output'];
};

export type UserDashboardConfigurationPatch = {
	primaryColor: Scalars['String']['input'];
	secondaryColor: Scalars['String']['input'];
	subTitle: Scalars['String']['input'];
	title: Scalars['String']['input'];
};

export type UserDashboardConfigurationResponse = {
	__typename?: 'UserDashboardConfigurationResponse';
	id: Scalars['String']['output'];
	primaryColor?: Maybe<Scalars['String']['output']>;
	secondaryColor?: Maybe<Scalars['String']['output']>;
	subTitle?: Maybe<Scalars['String']['output']>;
	title?: Maybe<Scalars['String']['output']>;
};

export type UserEducation = {
	__typename?: 'UserEducation';
	degree?: Maybe<Scalars['String']['output']>;
	description?: Maybe<Scalars['String']['output']>;
	endMonth?: Maybe<Scalars['Float']['output']>;
	endYear?: Maybe<Scalars['Float']['output']>;
	field?: Maybe<Scalars['String']['output']>;
	id: Scalars['String']['output'];
	logoUrl?: Maybe<Scalars['String']['output']>;
	organizationEmblem?: Maybe<Emblem>;
	organizationId?: Maybe<Scalars['String']['output']>;
	school?: Maybe<Scalars['String']['output']>;
	skillIds: Array<Scalars['String']['output']>;
	startMonth?: Maybe<Scalars['Float']['output']>;
	startYear?: Maybe<Scalars['Float']['output']>;
	websiteUrl?: Maybe<Scalars['String']['output']>;
};

export type UserEducationResponse = {
	__typename?: 'UserEducationResponse';
	education: Array<UserEducation>;
};

export type UserEducationUpdate = {
	degree?: InputMaybe<Scalars['String']['input']>;
	description?: InputMaybe<Scalars['String']['input']>;
	endMonth?: InputMaybe<Scalars['Float']['input']>;
	endYear?: InputMaybe<Scalars['Float']['input']>;
	field?: InputMaybe<Scalars['String']['input']>;
	logoUrl?: InputMaybe<Scalars['String']['input']>;
	organizationId?: InputMaybe<Scalars['String']['input']>;
	school?: InputMaybe<Scalars['String']['input']>;
	startMonth?: InputMaybe<Scalars['Float']['input']>;
	startYear?: InputMaybe<Scalars['Float']['input']>;
	websiteUrl?: InputMaybe<Scalars['String']['input']>;
};

export type UserExperienceCompany = {
	__typename?: 'UserExperienceCompany';
	id: Scalars['ID']['output'];
	logoUrl?: Maybe<Scalars['String']['output']>;
	name?: Maybe<Scalars['String']['output']>;
	organizationId?: Maybe<Scalars['String']['output']>;
	positions: Array<UserExperiencePosition>;
	skillIds: Array<Scalars['String']['output']>;
	userId: Scalars['String']['output'];
	websiteUrl?: Maybe<Scalars['String']['output']>;
};

export type UserExperienceCompanyAndPositionCreation = {
	companyRequest: UserExperienceCompanyUpdate;
	positionRequest: UserExperiencePositionUpdate;
};

export type UserExperienceCompanyUpdate = {
	logoUrl?: InputMaybe<Scalars['String']['input']>;
	name?: InputMaybe<Scalars['String']['input']>;
	organizationId?: InputMaybe<Scalars['String']['input']>;
	websiteUrl?: InputMaybe<Scalars['String']['input']>;
};

export type UserExperiencePosition = {
	__typename?: 'UserExperiencePosition';
	description?: Maybe<Scalars['String']['output']>;
	employmentType: EmploymentType;
	endMonth?: Maybe<Scalars['Float']['output']>;
	endYear?: Maybe<Scalars['Float']['output']>;
	id: Scalars['ID']['output'];
	jobTitle: Scalars['String']['output'];
	location: Scalars['String']['output'];
	locationType: EmploymentLocationType;
	startMonth: Scalars['Float']['output'];
	startYear: Scalars['Float']['output'];
	userExperienceCompanyId: Scalars['String']['output'];
};

export type UserExperiencePositionUpdate = {
	description?: InputMaybe<Scalars['String']['input']>;
	employmentType: EmploymentType;
	endMonth?: InputMaybe<Scalars['Float']['input']>;
	endYear?: InputMaybe<Scalars['Float']['input']>;
	jobTitle: Scalars['String']['input'];
	location: Scalars['String']['input'];
	locationType: EmploymentLocationType;
	startMonth: Scalars['Float']['input'];
	startYear: Scalars['Float']['input'];
};

export type UserExperienceResponse = {
	__typename?: 'UserExperienceResponse';
	companies: Array<UserExperienceCompany>;
};

export type UserExtraData = {
	__typename?: 'UserExtraData';
	companyName?: Maybe<Scalars['String']['output']>;
	companyTitle?: Maybe<Scalars['String']['output']>;
	fullName?: Maybe<Scalars['String']['output']>;
	initials?: Maybe<Scalars['String']['output']>;
	isSiteUser: Scalars['Boolean']['output'];
	siteUserId?: Maybe<Scalars['ID']['output']>;
	siteUserRole?: Maybe<Scalars['ID']['output']>;
};

export type UserLogin = {
	__typename?: 'UserLogin';
	displayName?: Maybe<Scalars['String']['output']>;
	emailAddress: Scalars['String']['output'];
	isSiteAdmin?: Maybe<Scalars['Boolean']['output']>;
	registered: Scalars['Boolean']['output'];
	siteUserId?: Maybe<Scalars['ID']['output']>;
	siteUserInvitation?: Maybe<SiteUserInvitation>;
	standardUserId?: Maybe<Scalars['ID']['output']>;
	userId: Scalars['ID']['output'];
};

export type UserOrgPermissions = {
	__typename?: 'UserOrgPermissions';
	isOrganizationAdmin?: Maybe<Scalars['Boolean']['output']>;
	organizationId: Scalars['ID']['output'];
	permissions?: Maybe<Array<Scalars['String']['output']>>;
};

export type UserProfile = {
	__typename?: 'UserProfile';
	about?: Maybe<Scalars['String']['output']>;
	adjusterLicenses?: Maybe<Array<AdjusterLicensingSummary>>;
	affiliatedOrganizationConnections: Array<Connection>;
	avatarFile?: Maybe<File>;
	backgroundCheckDate?: Maybe<Scalars['Date']['output']>;
	companyName?: Maybe<Scalars['String']['output']>;
	companyTitle?: Maybe<Scalars['String']['output']>;
	connection?: Maybe<Connection>;
	conversationInsuranceProfileLink?: Maybe<Scalars['String']['output']>;
	displayLocation?: Maybe<Scalars['String']['output']>;
	displayTemporaryLocation?: Maybe<DisplayTemporaryLocation>;
	drugTestDate?: Maybe<Scalars['Date']['output']>;
	facebookProfileLink?: Maybe<Scalars['String']['output']>;
	following?: Maybe<Scalars['Boolean']['output']>;
	id: Scalars['ID']['output'];
	jobFunctions?: Maybe<Array<JobFunctions>>;
	languageIds?: Maybe<Array<Scalars['String']['output']>>;
	linkedinProfileLink?: Maybe<Scalars['String']['output']>;
	name: PersonName;
	private: Scalars['Boolean']['output'];
	workCodes: Array<Scalars['String']['output']>;
	xProfileLink?: Maybe<Scalars['String']['output']>;
	xactimateAddresses?: Maybe<Array<XactimateAddress>>;
};

export type UserProfileEffectivePrivacy = {
	__typename?: 'UserProfileEffectivePrivacy';
	aspect: Scalars['String']['output'];
	mayAccess: Scalars['Boolean']['output'];
	targetUserId: Scalars['String']['output'];
};

export type UserProfileUpdate = {
	about?: InputMaybe<Scalars['String']['input']>;
	avatarUploadToken?: InputMaybe<Scalars['String']['input']>;
	backgroundCheckDate?: InputMaybe<Scalars['Date']['input']>;
	companyName?: InputMaybe<Scalars['String']['input']>;
	companyTitle?: InputMaybe<Scalars['String']['input']>;
	conversationInsuranceProfileLink?: InputMaybe<Scalars['String']['input']>;
	drugTestDate?: InputMaybe<Scalars['Date']['input']>;
	facebookProfileLink?: InputMaybe<Scalars['String']['input']>;
	jobFunctions?: InputMaybe<Array<JobFunctions>>;
	languageIds: Array<Scalars['String']['input']>;
	linkedinProfileLink?: InputMaybe<Scalars['String']['input']>;
	name: PersonNameInput;
	workCodes: Array<Scalars['String']['input']>;
	xProfileLink?: InputMaybe<Scalars['String']['input']>;
	xactimateAddresses?: InputMaybe<Array<XactimateAddressUpdate>>;
};

export type UserRegistration = {
	birthDate?: InputMaybe<Scalars['Date']['input']>;
	cellPhone: PhoneNumberInput;
	languageIds: Array<Scalars['String']['input']>;
	name: PersonNameInput;
	primaryAddress: AddressInput;
};

export type UserSkill = {
	__typename?: 'UserSkill';
	displayOrder: Scalars['Float']['output'];
	endorsedByCurrentUser: Scalars['Boolean']['output'];
	endorsementCount: Scalars['Float']['output'];
	id: Scalars['String']['output'];
	skill: Skill;
	skillId: Scalars['String']['output'];
};

export type UserSkillCreate = {
	displayOrder: Scalars['Float']['input'];
	placesUsed: Array<UserSkillPlaceUsedCreate>;
	skillId: Scalars['String']['input'];
};

export type UserSkillDisplayOrder = {
	displayOrder: Scalars['Float']['input'];
	userSkillId: Scalars['String']['input'];
};

export type UserSkillEndorsement = {
	__typename?: 'UserSkillEndorsement';
	endorsedOnUtc: Scalars['Date']['output'];
	endorsingUserId: Scalars['String']['output'];
	id: Scalars['String']['output'];
	showOnProfile: Scalars['Boolean']['output'];
	userSkillId: Scalars['String']['output'];
};

export type UserSkillEndorsementResponse = {
	__typename?: 'UserSkillEndorsementResponse';
	endorsements: Array<UserSkillEndorsement>;
};

export type UserSkillPlaceUsed = {
	__typename?: 'UserSkillPlaceUsed';
	id: Scalars['String']['output'];
	userEducation?: Maybe<UserEducation>;
	userEducationId?: Maybe<Scalars['String']['output']>;
	userExperienceCompany?: Maybe<UserExperienceCompany>;
	userExperienceId?: Maybe<Scalars['String']['output']>;
	userId: Scalars['String']['output'];
};

export type UserSkillPlaceUsedCreate = {
	userEducationId?: InputMaybe<Scalars['String']['input']>;
	userExperienceId?: InputMaybe<Scalars['String']['input']>;
};

export type UserSkillPlacesUsedResponse = {
	__typename?: 'UserSkillPlacesUsedResponse';
	placesUsed: Array<UserSkillPlaceUsed>;
};

export type UserSkillPlacesUsedUpdateRequest = {
	placesUsed: Array<UserSkillPlaceUsedCreate>;
};

export type UserSkillsResponse = {
	__typename?: 'UserSkillsResponse';
	skills: Array<UserSkill>;
};

export enum UserType {
	SiteUser = 'SiteUser',
	SiteUserInvitation = 'SiteUserInvitation',
	SocialUser = 'SocialUser',
}

export type ValidationRules = {
	__typename?: 'ValidationRules';
	properties: Array<PropertyValidationRules>;
	typeName: Scalars['ID']['output'];
};

export type Viewport = {
	__typename?: 'Viewport';
	northeast: Location;
	southwest: Location;
};

export type VirusScanResult = {
	blobName?: InputMaybe<Scalars['String']['input']>;
	container?: InputMaybe<Scalars['String']['input']>;
	rawResult?: InputMaybe<Scalars['String']['input']>;
	status: Scalars['String']['input'];
};

export enum VirusStatus {
	Clean = 'Clean',
	Infected = 'Infected',
	Pending = 'Pending',
	ScanFailed = 'ScanFailed',
	TooLargeToScan = 'TooLargeToScan',
}

export type WorkType = {
	__typename?: 'WorkType';
	displayName: Scalars['String']['output'];
	workCode: Scalars['ID']['output'];
};

export type XactimateAddress = {
	__typename?: 'XactimateAddress';
	xactNetAddress: Scalars['String']['output'];
	xactimateVersion: Scalars['String']['output'];
};

export type XactimateAddressUpdate = {
	xactNetAddress: Scalars['String']['input'];
	xactimateVersion: Scalars['String']['input'];
};

export type ZendeskAuthResponse = {
	__typename?: 'ZendeskAuthResponse';
	jwt?: Maybe<Scalars['String']['output']>;
	url: Scalars['String']['output'];
};
